import { Badge, Button, Card, Col, Divider, Form, Image, Input, InputNumber, List, Modal, Row, Space, Tabs, message, Upload, Spin, Tag, Alert, Radio, Switch } from 'antd';
import VirtualList from 'rc-virtual-list';
import Search from 'antd/es/input/Search';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiCall } from '../../API/RestApi';
import { currencyFormat } from '../../Utils/formatCurrency';
import { urlProduct } from '../../Utils/globalUrl';
import { CloseOutlined, PlusOutlined, FilePdfOutlined, MinusOutlined, ShoppingCartOutlined, PrinterOutlined, InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import { modalError, modalSuccess } from '../../Component/Modal/ModalLayout';
import BarcodeReader from 'react-barcode-reader'
import { writePrint, writePrintHistory, writePrintTry } from '../../Utils/PrintThermal';
import { useSelector } from 'react-redux';
import { dateFormat } from '../../Utils/formatDate';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isPromoActive, posPriceBeforeDiscount, posPriceBeforeDiscountNum, posPriceDiscount, posPriceDiscountPercent, posPriceDiscountPercentNum, posPriceDiscountPrice, posPriceNum } from '../../Utils/POS/posPrice';
import TabPane from 'antd/es/tabs/TabPane';
import { io } from 'socket.io-client';
import TextArea from 'antd/es/input/TextArea';

const { confirm } = Modal;

const { Dragger } = Upload;
const socket = io('https://pos-api.boldestore.com');
// const socket = io('http://localhost:8010');

function POS() {
    const token = useSelector((state) => state.user.token);
    const user = useSelector((state) => state.user.user);
    const serialPort = useSelector(state => state.print.port);
    const location = useLocation();
    const navigate = useNavigate();
    const [formMembership] = Form.useForm();
    const [formDetailProduct] = Form.useForm();

    //DATA
    const [isEcommerce, setIsEcommerce] = useState(false);
    const [note, setNote] = useState('');
    const [loadingAll, setLoadingAll] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPay, setLoadingPay] = useState(false);
    const [load, setLoad] = useState(0);
    const [product, setProduct] = useState([]);
    const [category, setCategory] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [modalDetailProduct, setModalDetailProduct] = useState(false);
    const [indexDetailProduct, setIndexDetailProduct] = useState(null);

    const [modalMinPurchase, setModalMinPurchase] = useState(false);
    const [searchMinPurchase, setSearchMinPurchase] = useState('');
    const [imageReceiptUrl, setImageReceiptUrl] = useState(null);
    const [imageReceiptFile, setImageReceiptFile] = useState(null);

    //MODAL / POPUP
    const [modalCategory, setModalCategory] = useState(false);
    const [modalMembership, setModalMembership] = useState(false);
    const [modalFormMembership, setModalFormMembership] = useState(false);
    const [modalFormMethod, setModalFormMethod] = useState(false);
    const [modalHoldTrans, setModalHoldTrans] = useState(false);
    const [modalBill, setModalBill] = useState(false);
    const [modalDone, setModalDone] = useState(false);
    const [modalUploadReceipt, setModalUploadReceipt] = useState(false);

    //PARAMS API
    const [textSearch, setTextSearch] = useState('');
    const [urlBase, setUrlBase] = useState('');
    const [categoryId, setCategoryId] = useState();
    const [valuePromo, setValuePromo] = useState();
    const [valueMethod, setValueMethod] = useState('tunai');
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [listHoldTransakasi, setListHoldCustomer] = useState([]);
    const [listBill, setListBill] = useState([]);
    const [transactionId, setTransactionId] = useState(null);
    const [valueCustomer, setValueCustomer] = useState(null);
    const [valueInputPoint, setValueInputPoint] = useState(0);


    const [activeButtonPay, setActiveButtonPay] = useState(true);
    const [statusEditPoint, setStatusEditPoint] = useState(false);
    const [methodPay, setMethodPay] = useState();
    const [voucherText, setVoucherText] = useState(null);

    //STATE
    const [listDevicePay, setListDevicePay] = useState([]);
    const [kasPay, setKasPay] = useState();
    // const [statusStore, setStatusStore] = useState(false);
    const [productCart, setProductCart] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalQty, setTotalQty] = useState(0);
    const [cardNumber, setCardNumber] = useState();
    const [pay, setPay] = useState();
    const [opsionalPrice, setOpsionalPrice] = useState([]);
    const [voucherPrice, setVoucherPrice] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [usePoint, setUsePoint] = useState(false);
    const [useVoucher, setUseVoucher] = useState(false);

    const [usedVouchers, setUsedVouchers] = useState([]);

    const [dataPrint, setDataPrint] = useState(null);
    const [loadSocket, setLoadSocket] = useState(false);
    const [cashbackMemberPoint, setCashbackMemberPoint] = useState([]);
    const [cashbackPoint, setCashbackPoint] = useState(0);
    const [isSendAccurate, setIsSendAccurate] = useState(false);
    const [minPurchaseCart, setMinPurchaseCart] = useState([]);
    const [selectedMinPromo, setSelectedMinPromo] = useState(null);

    const [shopMinPromo, setShopMinPromo] = useState([]);

    const optionPrice = [
        createOption('', 1.0),
        createOption('', 1.1),
        createOption('', 1.15),
    ];

    const getCartItemKey = (item) => {
        if (item.is_clearance === true) {
            return `clearance-${item.variant_product_id}-${item.clearance_item_id || item.clearance_product_id}`;
        }

        return `normal-${item.variant_product_id}`;
    };

    const [selectPromo, setSelectPromo] = useState([
        {
            label: "Semua",
            status: true,
            value: ''
        },
        {
            label: "Clearance",
            status: false,
            value: 'clearance'
        },
    ]);

    const ContainerHeight = 400;
    //PAGES
    const [page, setPage] = useState({
        page: 1,
        total_page: 1
    });

    const [pageCustomer, setPageCustomer] = useState({
        page: 1,
        total_page: 1
    });

    const [pageBill, setPageBill] = useState({
        page: 1,
        total_page: 1
    });


    const filteredShopMinPromo = shopMinPromo.map((promo) => {
        const keyword = searchMinPurchase.toLowerCase();

        return {
            ...promo,
            min_purchase_items: (promo.min_purchase_items || []).filter((item) => {
                const productName = item.product?.product_name || '';
                const variantName = item.variant_product?.variant_name || '';
                const sku = item.variant_product?.SKU || '';

                return (
                    productName.toLowerCase().includes(keyword) ||
                    variantName.toLowerCase().includes(keyword) ||
                    sku.toLowerCase().includes(keyword)
                );
            }),
        };
    }).filter((promo) => promo.min_purchase_items.length > 0);

    useEffect(() => {
        const state = location.state;
        if (loadSocket === false) {
            socket.emit('joinRoom', state.item.outlet.outlet_id);
            socket.emit('reset', state.item.outlet.outlet_id);
            setLoadSocket(true);
        }
        if (state !== null) {
            localStorage.removeItem('selectedOutlet');
            var op = state.item.outlet.outlet_akuns;
            setIsSendAccurate(state.item.outlet.is_send_accurate);
            var opArr = ['EDC BCA', 'EDC MANDIRI', 'EDC BNI', 'EDC BRI', 'EDC Kredivo'];
            var row = [];
            for (let i = 0; i < opArr.length; i++) {
                var arr = op.filter(o => {
                    var opArrLowerCase = opArr[i].toLowerCase();
                    return o?.akun?.akun_name.toLowerCase().includes(opArrLowerCase);
                });
                if (arr.length > 0) {
                    for (let i2 = 0; i2 < arr.length; i2++) {
                        row.push({
                            id: arr[i2].akun.akun_no,
                            name: opArr[i],
                            status: false
                        });
                    }
                }
            }
            var arr2 = op.filter(o => {
                var opArrLowerCase = 'kas';
                return o?.akun?.akun_name.toLowerCase().includes(opArrLowerCase);
            });
            setKasPay({
                id: arr2.length > 0 ? arr2[0].akun.akun_no : null,
                name: arr2.length > 0 ? arr2[0]?.akun?.akun_name : null,
                status: false
            });
            var pages = '';
            var url = '';
            var sorting = '';
            setListDevicePay(row);
            if (page.page <= page.total_page) {
                var where = '';
                if (categoryId != null) {
                    where += '&categoryId=' + categoryId;
                }
                if (valuePromo != null) {
                    where += '&sorting=' + valuePromo;
                }
                pages = "&page=" + page.page;
                // url = '/productvariant?search=' + textSearch + '&outletId=' + state.item.outlet.outlet_id + pages + where + sorting + '&branchId=' + state.item.outlet.branch_id;
                if (valuePromo === 'clearance') {
                    const today = getTodayDay();

                    url = '/clearance?nopage=true&is_active=true'
                        + '&outletId=' + state.item.outlet.outlet_id
                        + '&day=' + today;
                } else {
                    url = '/productvariant?search=' + textSearch
                        + '&outletId=' + state.item.outlet.outlet_id
                        + pages
                        + where
                        + sorting
                        + '&branchId=' + state.item.outlet.branch_id;
                }
                callApi('GET', url, 'product')
            }

            // callApi('GET', '/shopminpromoactive', 'shopminpromo');
            callApi('GET', '/category?nopage=true', 'category');
            callApi('GET', '/customer?page=' + pageCustomer.page, 'customer');
            // if (pageBill.page <= pageBill.total_page && urlBase !== '') {
            //     var dates = moment(new Date()).format('YYYY-MM-DD');
            //     callApi('GET', '/transaction?date=' + dates + '&outletId=' + state.item.outlet.outlet_id + "&page=" + pageBill.page, 'transactionBill');
            // }
        } else {
            navigate('/listoutlet');
        }

        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // JSON.stringify(pageBill),
        load,
    ]);

    const loadMoreData = () => {
        if (valuePromo === 'clearance') {
            return;
        }

        if (!loading && product.length < page.total_page) {
            const state = location.state;
            let where = '';

            if (categoryId != null) {
                where += '&categoryId=' + categoryId;
            }

            const nextPage = page.page + 1;
            const url = '/productvariant?search=' + textSearch
                + '&outletId=' + state.item.outlet.outlet_id
                + '&page=' + nextPage
                + where
                + '&branchId=' + state.item.outlet.branch_id;

            setLoading(true);
            callApi('GET', url, 'product');
            setPage({
                ...page,
                page: nextPage
            });
        }
    };

    const loadMoreDataBill = () => {
        if (!loading && listBill.length < pageBill.total_page) {
            const state = location.state;
            var dates = moment(new Date()).format('YYYY-MM-DD');

            const nextPage = page.page + 1;
            const url = '/transaction?date=' + dates + '&outletId=' + state.item.outlet.outlet_id + "&page=" + pageBill.page;

            setLoading(true);
            callApi('GET', url, 'transactionBill');
            setPageBill({
                ...pageBill,
                page: nextPage,
            });
        }
    };

    const loadMoreDataCustomer = () => {
        if (pageCustomer.page <= pageCustomer.total_page) {
            const nextPage = pageCustomer.page + 1;
            const url = '/customer?search=' + textSearch + "&page=" + nextPage;

            callApi('GET', url, 'customer');
            setPage({
                ...page,
                page: nextPage
            });
        }
    };

    const callApi = (method, url, type, values = null, header = null, data2 = null) => {
        if (loading) {
            return;
        }
        var headers = {
            Authorization: 'Bearer ' + token,
        }
        if (header !== null) {
            headers = header;
        }

        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: headers
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                response(type, res, values, data2);
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            console.log(e.message);
        })
    }

    function debounce(func, delay) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
        };
    }

    const debouncedSearchdata = (value, type) => {
        setTextSearch(value);
        switch (type) {
            case 'product':
                setProduct([])
                setPage({
                    page: 1,
                    total_page: 1
                });
                setLoad(load + 1)
                setLoading(false)
                break;
            case 'category':
                var text = value;
                if (text === null || text === '') {
                    setCategory(categoryData)
                } else {
                    const arr = [];
                    categoryData.find(item => {
                        const op = new RegExp(".*" + text + ".*", 'ig');
                        const hsl = item.category_name.match(op);
                        if (hsl != null) {
                            arr.push(item)
                        }
                    }
                    );
                    setCategory(arr)
                }
                break;
            case 'customer':
                setPageCustomer({
                    page: 1,
                    total_page: 1
                })
                callApi('GET', '/customer?search=' + value + '&page=1', 'customer');
                break;
            case 'transaction':
                setPageBill({
                    page: 1,
                    total_page: 1
                })
                const state = location.state;
                var dates = moment(new Date()).format('YYYY-MM-DD');
                callApi('GET', '/transaction?search=' + value + '&date=' + dates + '&outletId=' + state.item.outlet.outlet_id + "&page=1", 'transactionBill');
                break;
            default:
                break;
        }
    }

    const searchdata = debounce(debouncedSearchdata, 900);

    const response = async (url, res, data = null, data2 = null) => {
        const state = location.state;
        switch (url) {
            case 'customerScan':
                var item = res.data;
                if (item.is_used === false) {
                    modalError(item.name + ' tidak bisa menggunakan point member');
                } else {
                    SelectedCustomer(item);
                }
                break;
            case 'product':
                setLoading(false);

                if (valuePromo === 'clearance') {

                    const clearanceData = res.data?.data || res.data || [];

                    const clearanceItems = [];

                    clearanceData.forEach((clearance) => {
                        if (clearance.clearance_items && clearance.clearance_items.length > 0) {
                            clearance.clearance_items.forEach((item) => {
                                if (item.variant_product !== null) {
                                    clearanceItems.push({
                                        ...item.variant_product,
                                        product: item.product,
                                        product_id: item.product_id,
                                        variant_product_id: item.variant_product_id,
                                        price_clearance: item.price,
                                        edit_price: item.price,
                                        is_clearance: true,
                                        clearance_product_id: item.clearance_product_id,
                                        clearance_item_id: item.clearance_item_id,
                                    });
                                }
                            });
                        }
                    });

                    setProduct(clearanceItems);
                    setPage({
                        page: 1,
                        total_page: clearanceItems.length
                    });
                    setLoading(false);
                    break;
                }

                const filteredRows = res.data.rows.filter(row => row.variant_product !== null);

                setProduct(prevProduct => [...prevProduct, ...filteredRows]);

                var sorting = '';
                var where = '';

                if (categoryId != null) {
                    where += '&categoryId=' + categoryId;
                }

                var nextPage = page.page + 1;

                const newUrl = `/productvariant?search=${textSearch}&page=${nextPage}${where}${sorting}&outletId=${state.item.outlet.outlet_id}&branchId=${state.item.outlet.branch_id}`;

                setUrlBase(newUrl);
                setPage({
                    page: nextPage,
                    total_page: res.data.count
                });
                setLoading(false);
                break;
            case 'category':
                setCategory(res.data);
                setCategoryData(res.data);
                break;
            case 'customer':
                if (res.data.rows.length > 0) {
                    if (pageCustomer.page > 1) {
                        setCustomer([...customer, ...res.data.rows]);
                    } else {
                        setCustomer(res.data.rows);
                    }
                }
                setLoading(false);
                break;
            case 'add_customer':
                setPageCustomer({
                    page: 1,
                    total_page: 1
                })
                callApi('GET', '/customer?page=1', 'customer');
                formMembership.resetFields();
                setModalFormMembership(false);
                setLoading(false);
                modalSuccess('Berhasil Tambah Customer ke Membership');
                break;
            case 'transactionnoaccurate':
                socket.emit('newTransaction', {
                    transactions: [],
                    total: 0,
                    outletId: state.item.outlet.outlet_id,
                    voucher: 0,
                    point: 0,
                    pay: true
                });
                var data_print = {
                    ...data2,
                    transaction: res.transaction
                };
                data_print.transaction_code = res.transaction_code;
                setDataPrint(data_print);
                setPaymentMethod(null);
                setActiveButtonPay(false);
                if (serialPort !== null) {
                    writePrint(serialPort, data_print);
                }
                setTransactionId(res.data.transaction_id);
                setTotalQty(0);
                setLoadingPay(false);
                setModalDone(true);
                setLoadingAll(false);
                callApi('GET', '/customer?page=' + pageCustomer.page, 'customer');
                break;
            case 'transactionInvoice':
                socket.emit('newTransaction', {
                    transactions: [],
                    total: 0,
                    outletId: state.item.outlet.outlet_id,
                    voucher: 0,
                    point: 0,
                    pay: true
                });
                if (res.data.s === false) {
                    modalSuccess('Data Telah Tersimpan ke Bill');
                    setTotalQty(0);
                    modalError(res.data.d[0]);
                    setPaymentMethod(null);
                    setActiveButtonPay(false);
                    setLoadingPay(false);
                    removeState();
                } else {
                    // var json = {
                    //     content: 'Ada Transaksi Masuk'
                    // }
                    // callApi('POST', '/notification/push', 'notification', json);
                    var data_print = data2;
                    data_print.transaction_code = res.transaction_code;
                    setDataPrint(data_print);
                    setTotalQty(0);
                    setPaymentMethod(null);
                    setActiveButtonPay(false);
                    if (serialPort !== null) {
                        writePrint(serialPort, data_print);
                    }
                    setTransactionId(res.data.transaction_id);
                    setLoadingPay(false);
                    setModalDone(true);
                }
                setLoadingAll(false);
                break;
            case 'transaction':
                socket.emit('newTransaction', {
                    transactions: [],
                    total: 0,
                    outletId: state.item.outlet.outlet_id,
                    voucher: 0,
                    point: 0,
                    pay: true
                });
                if (res.data_accurate !== undefined) {
                    if (res.data_accurate.s === false) {
                        modalSuccess('Data Telah Tersimpan ke Bill');
                        setTotalQty(0);
                        modalError(res.data_accurate.d[0].d[0]);
                        setPaymentMethod(null);
                        setActiveButtonPay(false);
                        setLoadingPay(false);
                        removeState();
                    } else {
                        // var json = {
                        //     content: 'Ada Transaksi Masuk'
                        // }
                        // callApi('POST', '/notification/push', 'notification', json);

                        var data_print = {
                            ...data2,
                            transaction: res.transaction
                        };
                        data_print.transaction_code = res.transaction_code;
                        setDataPrint(data_print);
                        setTotalQty(0);
                        setPaymentMethod(null);
                        setActiveButtonPay(false);
                        if (serialPort !== null) {
                            writePrint(serialPort, data_print);
                        }
                        setTransactionId(res.data.transaction_id);
                        setLoadingPay(false);
                        setModalDone(true);
                    }
                } else {
                    if (res.data.s === true) {
                        // var json2 = {
                        //     content: 'Ada Transaksi Masuk'
                        // }
                        // callApi('POST', '/notification/push', 'notification', json2);

                        var data_print2 = {
                            ...data2,
                            transaction: res.transaction
                        };
                        data_print2.transaction_code = res.transaction_code;
                        setTotalQty(0);
                        setDataPrint(data_print2);
                        setPaymentMethod(null);
                        setActiveButtonPay(false);
                        if (serialPort !== null) {
                            writePrint(serialPort, data_print2);
                        }
                        setTransactionId(res.data.transaction_id);
                        setLoadingPay(false);
                        setModalDone(true);
                    } else {
                        if (res.data.d[0].d !== undefined) {
                            modalSuccess('Data Telah Tersimpan ke Bill');
                            setTotalQty(0);
                            modalError(res.data.d[0].d[0]);
                            setPaymentMethod(null);
                            setActiveButtonPay(false);
                            setLoadingPay(false);
                            removeState();
                        } else {
                            modalSuccess('Data Telah Tersimpan ke Bill');
                            setTotalQty(0);
                            modalError(res.data.d[0]);
                            removeState();
                        }
                    }
                }
                setLoadingAll(false);
                callApi('GET', '/customer?page=' + pageCustomer.page, 'customer');
                break;
            case 'notification':

                break;
            case 'transactionBill':
                var dataBill = res.data.rows;
                for (let i = 0; i < dataBill.length; i++) {
                    var qty = 0;
                    for (let i2 = 0; i2 < dataBill[i].transaction_products.length; i2++) {
                        var bns = dataBill[i].transaction_products[i2].bonus;
                        if (bns !== null && bns !== undefined) {
                            if (bns.bonus_product !== null && bns.bonus_product !== undefined) {
                                qty += bns.bonus_product.qty;
                            }
                        }
                        qty += dataBill[i].transaction_products[i2].qty;
                    }
                    dataBill[i].total_qty = qty;
                }
                setListBill(dataBill)
                setPageBill({
                    page: pageBill.page + 1,
                    total_page: res.data.count
                });
                if (urlBase !== '') {
                    setModalBill(true);
                }
                setLoading(false);
                break;
            case 'receipt':
                modalSuccess('Berhasil Upload Struk');
                setTransactionId(null);
                break;
            case 'uploadReceipt':
                setPageBill({
                    page: 1,
                    total_page: 1
                });
                message.success('file uploaded successfully.');
                setTransactionId(null);
                setModalUploadReceipt(false);
                break;
            case 'checkPackage':
                var row2 = [];
                var item2 = res.data;
                for (let i = 0; i < data2.length; i++) {
                    if (data2[i].statusBonus !== undefined) {
                        data2.splice(i, 1);
                    }
                }
                if (item2.length > 0) {
                    for (let i = 0; i < item2.length; i++) {
                        item2[i].variant_product.price = 0;
                        item2[i].variant_product.statusBonus = true;
                        item2[i].variant_product.qty = item2[i].qty;
                        row2.push(item2[i].variant_product);
                    }
                }
                var arr = [...data2, ...row2];
                setProductCart(arr);
                setLoading(false);
                break;
            case 'checkTransaction':
                var row3 = [];
                var dataJson = data2;
                var item3 = res.data.rows;
                for (let i = 0; i < dataJson.length; i++) {
                    if (dataJson[i].statusTransBonus !== undefined) {
                        dataJson.splice(i, 1);
                    }
                }
                // console.log(dataJson)
                if (item3.length > 0) {
                    for (let i = 0; i < item3.length; i++) {
                        item3[i].bonus_product.variant_product.price = 0;
                        item3[i].bonus_product.variant_product.statusTransBonus = true;
                        item3[i].bonus_product.variant_product.qty = 1;
                        row3.push(item3[i].bonus_product.variant_product);
                    }
                }
                var arr = [...dataJson, ...row3];
                setProductCart(arr);
                break;
            case 'checkBarcode':
                var item = res.data.rows;
                updateProdukCart(item[0], 0);
                break;
            case 'voucher':
                var itemVoucher = res.data.data[0];
                if (itemVoucher != null) {
                    const startDateTime = new Date(itemVoucher.start_datetime);
                    const endDateTime = new Date(itemVoucher.end_datetime);
                    const now = new Date();

                    // ✅ Cek apakah voucher fixed
                    const isFixed = itemVoucher.is_fixed === true;

                    if (!isFixed && (now < startDateTime || now > endDateTime)) {
                        modalError('Voucher sudah tidak berlaku dari tanggal ' + endDateTime);
                    } else if (!isFixed && itemVoucher.is_used === true) {
                        modalError('Voucher telah digunakan');
                    } else {
                        if (Number(grandTotal) >= Number(itemVoucher.min_buy)) {
                            setUsedVouchers([...usedVouchers, itemVoucher]);
                            grandTotalCurrencyValue({
                                voucher_value: [...usedVouchers, itemVoucher],
                                use_voucher: true
                            });
                            setVoucherText(null);
                        } else {
                            modalError('Minimal Pembelian Kurang dari ' + currencyFormat(itemVoucher.min_buy));
                        }
                    }
                } else {
                    modalError('Voucher tidak ditemukan');
                }

                break;
            case 'checkCashbackMember':
                var point = 0;
                for (let i = 0; i < res.data.length; i++) {
                    const pointProd = res.data[i];
                    const item = data2[i];
                    if (pointProd.status === 'percent') {
                        if (item.edit_price !== undefined) {
                            point += Number(item.edit_price) * Number(item.qty) * (Number(pointProd.point) / 100);
                        } else {
                            point += Number(posPriceNum(item, isEcommerce)) * Number(item.qty) * (Number(pointProd.point) / 100);
                        }
                    } else {
                        if (pointProd.status_disc === 'minbuy') {
                            point = Number(pointProd.point);
                        } else {
                            point += Number(item.qty) * Number(pointProd.point);
                        }
                    }
                }
                setCashbackMemberPoint(res.data);
                setCashbackPoint(point);
                break;
            case 'shopminpromo': {
                const promos = res.data?.data || res.data || [];
                const totalNow = data2?.total || 0;
                const cartNow = data2?.cart || productCart;

                const validMinPurchaseIds = promos.map((promo) =>
                    Number(promo.min_purchase_product_id)
                );

                const filteredMinCart = minPurchaseCart.filter((item) =>
                    validMinPurchaseIds.includes(Number(item.min_purchase_product_id))
                );

                setShopMinPromo(promos);
                setMinPurchaseCart(filteredMinCart);

                grandTotalCurrencyValue({
                    product_cart: cartNow,
                    min_purchase_cart: filteredMinCart,
                });

                setLoading(false);
                break;
            }
            case 'verifypointcustomer':
                var item = res.data;
                setValueCustomer(item);
                setValueInputPoint(res.point);
                checkCashBackPointMember(null, item);
                setUsePoint(false);
                grandTotalCurrencyValue({ total: totalPrice });
                closeModal();
                break;
            default:
                setLoading(false);
                break;
        }
    }

    const removeState = () => {
        var row = listDevicePay;
        for (let i2 = 0; i2 < row.length; i2++) {
            row[i2].status = false;
        }
        setNote('');
        setLoading(false);
        setMinPurchaseCart([]);
        setShopMinPromo([]);
        // setValueMethod('tunai');
        setListDevicePay(row);
        setCardNumber();
        setProductCart([]);
        setUsePoint(false);
        setValueCustomer(null);
        setPay();
        setTotalPrice(0);
        setGrandTotal(0);
        setVoucherPrice(0);
        setVoucherText(null);
        setModalDone(false);
        setValueInputPoint(0);
        setPaymentMethod(null);
        setActiveButtonPay(true);
        setLoadingPay(false);
        setUsedVouchers([])
    }

    const openModal = (type) => {
        switch (type) {
            case 'category':
                setModalCategory(true);
                break;
            case 'membership':
                loadMoreDataCustomer();
                setModalMembership(true);
                break;
            case 'form_membership':
                setModalFormMembership(true);
                break;
            case 'method':
                setModalFormMethod(true);
                var gTotal = grandTotal;
                const p = createPrice(gTotal, optionPrice);
                var roundingMultiplier = 5000;
                if (gTotal >= 5000 && gTotal < 10000) {
                    roundingMultiplier = 5000;
                } else if (gTotal >= 10000 && gTotal < 50000) {
                    roundingMultiplier = 10000;
                } else if (gTotal >= 50000 && gTotal < 100000) {
                    roundingMultiplier = 50000;
                } else if (gTotal > 100000) {
                    roundingMultiplier = 50000;
                }
                const row = calculateTotalPrice(p.basePrice, p.options, roundingMultiplier).map(option => option.totalPrice);
                setOpsionalPrice(row);
                break;
            case 'hold':
                setModalHoldTrans(true);
                break;
            case 'bill':
                setListBill([])
                setPageBill({
                    page: 1,
                    total_page: 1
                })
                const state = location.state;
                var dates = moment(new Date()).format('YYYY-MM-DD');
                callApi('GET', '/transaction?date=' + dates + '&outletId=' + state.item.outlet.outlet_id + "&page=1", 'transactionBill');
                break;
            default:
                break;
        }
    }

    const closeModal = () => {
        setLoading(false);
        setModalMinPurchase(false);
        setSearchMinPurchase('');
        setModalCategory(false);
        setModalMembership(false);
        setModalFormMethod(false);
        setModalHoldTrans(false);
        setModalBill(false);
        setModalDone(false);
        setModalDetailProduct(false);
        setIndexDetailProduct(null);
    }

    const searchProductBy = (item, type) => {
        if (type === 'category') {
            setCategoryId(item.category_id);
            setProduct([]);
            setPage({
                page: 1,
                total_page: 1
            });
            setLoad(load + 1);
            closeModal();
        }
    }

    // const updateStatusOutlet = () => {
    //     const state = location.state;
    //     var data = {
    //         outlet_id: state.item.outlet.outlet_id,
    //         isClosed: statusStore
    //     };
    //     callApi('PUT', '/outletstatus', 'outletstatus', data);
    // }

    const searchPromoProduk = (index) => {
        var row = JSON.parse(JSON.stringify(selectPromo));
        for (let i = 0; i < row.length; i++) {
            row[i].status = false;
        }
        row[index].status = true;
        setValuePromo(row[index].value);
        setProduct([]);
        setPage({
            page: 1,
            total_page: 1
        });
        setLoad(load + 1);
        setSelectPromo(row);
    }

    const getTodayDay = () => {
        const days = [
            'minggu',
            'senin',
            'selasa',
            'rabu',
            'kamis',
            'jumat',
            'sabtu',
        ];

        return days[new Date().getDay()];
    };

    const getMinPurchasePromo = (cart = productCart) => {
        const state = location.state;

        if (!state?.item?.outlet) return;

        const total = cart.reduce((acc, item) => {
            const price = item.edit_price !== undefined
                ? Number(item.edit_price)
                : Number(posPriceNum(item, isEcommerce));

            return acc + (price * Number(item.qty || 1));
        }, 0);

        if (total <= 0) {
            setShopMinPromo([]);
            setMinPurchaseCart([]);

            grandTotalCurrencyValue({
                product_cart: cart,
                min_purchase_cart: [],
            });

            return;
        }

        const today = getTodayDay();

        callApi(
            'GET',
            `/min-purchase?nopage=true&is_active=true&outletId=${state.item.outlet.outlet_id}&total=${total}&day=${today}`,
            'shopminpromo',
            null,
            null,
            {
                total,
                cart,
            }
        );
    };

    const addMinPurchaseItem = (item) => {
        const duplicate = minPurchaseCart.find(
            x => Number(x.variant_product_id) === Number(item.variant_product_id)
        );

        if (duplicate) {
            modalError('Produk tebus murah sudah ditambahkan');
            return;
        }

        const row = {
            ...item,
            qty: 1,
            is_min_purchase: true,
        };

        const newMinCart = [...minPurchaseCart, row];

        setMinPurchaseCart(newMinCart);
        grandTotalCurrencyValue({
            product_cart: productCart,
            min_purchase_cart: newMinCart,
        });
    };

    const deleteMinPurchaseItem = (record) => {
        const row = minPurchaseCart.filter(
            item => Number(item.variant_product_id) !== Number(record.variant_product_id)
        );

        setMinPurchaseCart(row);
        grandTotalCurrencyValue({
            product_cart: productCart,
            min_purchase_cart: row,
        });
    };

    const updateProdukCart = async (item, index) => {
        item.qty = 1;

        var price = 0;
        var row = JSON.parse(JSON.stringify(productCart));
        var arr = [];

        const selectedKey = getCartItemKey(item);

        if (row.length > 0) {
            var status = false;
            var i2 = 0;

            for (let i = 0; i < row.length; i++) {
                if (selectedKey === getCartItemKey(row[i])) {
                    i2 = i;
                    status = true;
                }
            }

            if (status === true) {
                row[i2].qty = row[i2].qty + 1;
                price = Number(posPriceNum(row[i2], isEcommerce));
                arr = row;
            } else {
                price = Number(posPriceNum(item, isEcommerce));

                if (item.edit_price !== undefined && item.is_clearance !== true) {
                    delete item.edit_price;
                    delete item.edit_discount_percent;
                    delete item.edit_discount_price;
                }

                arr = [...productCart, item];
            }
        } else {
            if (item.edit_price !== undefined && item.is_clearance !== true) {
                delete item.edit_price;
                delete item.edit_discount_percent;
                delete item.edit_discount_price;
            }

            price = Number(posPriceNum(item, isEcommerce));
            arr = [...productCart, item];
        }

        var total_qty = totalQty + 1;
        var total = Number(totalPrice) + Number(price);

        setTotalQty(total_qty);
        setTotalPrice(total);
        setGrandTotal(total);
        setProductCart(arr);

        grandTotalCurrencyValue({
            voucher_value: usedVouchers,
            point_value: valueCustomer,
            total: total,
            product_cart: arr
        });

        getMinPurchasePromo(arr);
        checkCashBackPointMember(arr, valueCustomer);
        setLoading(false);
    };

    const saveMembership = (ev) => {
        setLoading(true);
        ev.phone = Number(ev.phone).toString();
        callApi('POST', '/customer', 'add_customer', ev);
    }

    const updateQty = async (ev, index, type) => {
        setLoading(true);
        var row = JSON.parse(JSON.stringify(productCart));
        var price = posPriceNum(row[index]);
        if (row[index].edit_price !== undefined) {
            price = Number(row[index].edit_price);
        } else {
            price = posPriceNum(row[index]);
        }

        var total = 0;
        var total_qty = 0;
        if (type === 'edit') {
            row[index] = ev;
            row[index].edit_discount_price = posPriceBeforeDiscountNum(row[index]) - Number(ev.edit_price);
            if (row[index].edit_price_before !== undefined) {
                var totalProduct = Number(row[index].qty) * row[index].edit_price_before;
                var totalProductNow = Number(row[index].qty) * Number(price);
                total = (totalPrice - totalProduct) + totalProductNow;
            } else {
                var totalProduct = Number(row[index].qty) * posPriceNum(row[index]);
                var totalProductNow = Number(row[index].qty) * Number(price);
                total = (totalPrice - totalProduct) + totalProductNow;
            }
            setTotalPrice(total);
        } else if (type === 'add') {
            row[index].qty += 1;
            total_qty = totalQty + 1;
            total = totalPrice + Number(price);
            setTotalPrice(total);
            setTotalQty(total_qty);
        } else if (type === 'min') {
            if (Number(ev.qty) > 1) {
                row[index].qty -= 1;
                total_qty = totalQty - 1;
                total = totalPrice - Number(price);
                setTotalQty(total_qty);
                setTotalPrice(total);
            } else {
                total_qty = totalQty - 1;
                total = totalPrice - Number(price);
                setTotalQty(total_qty);
                setTotalPrice(total);
                row.splice(index, 1);
            }
        } else if (type === 'del') {
            if (row.length > 0) {
                total = totalPrice;
                total_qty = totalQty;
                for (let i = 0; i < row[index].qty; i++) {
                    total -= Number(price);
                    total_qty = totalQty - Number(row[index].qty);
                }
                if (productCart[index].edit_discount_percent !== undefined) {
                    delete row[index].edit_price;
                    delete row[index].edit_discount_percent;
                    delete row[index].edit_discount_price;
                }
                setTotalQty(total_qty);
                setTotalPrice(total);
                await row.splice(index, 1);
            } else {
                setTotalQty(0);
                setTotalPrice(0);
            }
        }
        // var dataPackage = {
        //     "variant_product": []
        // }    
        // // var qtyTrans = 0;
        // for (let i = 0; i < row.length; i++) {
        //     const item = row[i];
        //     // qtyTrans += Number(item.qty);
        //     dataPackage.variant_product.push({
        //         "variant_product_id": item.variant_product_id,
        //         "min_order": item.qty,
        //     })
        // }
        setProductCart(row);
        checkCashBackPointMember(row, valueCustomer);
        grandTotalCurrencyValue({ voucher_value: usedVouchers, point_value: valueCustomer, total: total, product_cart: row });
        getMinPurchasePromo(row);
        // callApi('POST', '/checkproductpackage', 'checkPackage', dataPackage, null, row);
        // var dataTransPromo = {
        //     "outlet_id": outlet.outlet_id,
        //     "qty": qtyTrans,
        //     "total": total
        // }
        // callApi('POST', '/checktransactionpromo', 'checkTransaction', dataTransPromo, null, row);


        setLoading(false);
    }

    const SelectedCustomer = (item) => {
        if (item.is_used === false) {
            modalError(item.name + ' tidak bisa menggunakan point member');
        } else {
            callApi('PUT', '/verifypointcustomer', 'verifypointcustomer', { phone: item.phone });
        }
    }

    const onHold = () => {
        var row = JSON.parse(JSON.stringify(productCart));
        let data = {
            customer: valueCustomer,
            date_hold: dateFormat(new Date()),
            product_cart: row,
            total: totalPrice
        }
        setListHoldCustomer([...listHoldTransakasi, data]);
        setTotalPrice(0);
        setMinPurchaseCart([]);
        setShopMinPromo([]);
        setProductCart([]);
        setTotalQty(0);
        setValueCustomer();
        grandTotalCurrencyValue({ product_cart: [], total: 0 });
    }

    const showHoldToProductCart = (item, index) => {
        setProductCart(item.product_cart);
        setListHoldCustomer(listHoldTransakasi);
        setTotalPrice(item.total);
        setValueCustomer(item.customer);
        var total_qty = 0;
        for (let i = 0; i < item.product_cart.length; i++) {
            const pc = item.product_cart[i];
            total_qty += pc.qty;
        }
        setTotalQty(total_qty);
        grandTotalCurrencyValue({ product_cart: item.product_cart, total: item.total });
        listHoldTransakasi.splice(index, 1)
        closeModal();
    }

    const saveMethod = () => {
        if (valueMethod != null) {
            var alertArr = false;
            var alertText = '';
            if (grandTotal > 0) {
                if (valueMethod === 'card') {
                    if (cardNumber !== undefined && cardNumber !== null && cardNumber !== '') {
                        if (paymentMethod !== undefined && paymentMethod !== null && paymentMethod !== '') {
                            if (usePoint === true) {
                                setMethodPay('card_point');
                                grandTotalCurrencyValue({ payment_method: paymentMethod, point: valueInputPoint, use_point: true });
                            } else {
                                setMethodPay('card');
                                grandTotalCurrencyValue({ payment_method: paymentMethod });
                            }
                            setActiveButtonPay(false);
                            closeModal();
                        } else {
                            alertArr = true;
                            alertText = 'Pilih Device Untuk Pembayaran';
                        }
                    } else {
                        alertArr = true;
                        alertText = 'ID Number Card Kosong';
                    }
                }

                if (valueMethod === 'tunai') {
                    if (Number(pay) >= grandTotal) {
                        if (usePoint === true) {
                            grandTotalCurrencyValue({
                                payment_method: {
                                    name: "TUNAI",
                                },
                                point: valueInputPoint,
                                use_point: true
                            });
                            setMethodPay('tunai_point');
                        } else {
                            grandTotalCurrencyValue({
                                payment_method: {
                                    name: "TUNAI",
                                }
                            });
                            setMethodPay('tunai');
                        }
                        setActiveButtonPay(false);
                        setPaymentMethod({ name: "TUNAI" });
                        closeModal();
                    } else {
                        alertArr = true;
                        alertText = 'Nominal Pembayaran lebih kecil dari Total Pembayaran';
                    }
                }

                if (alertArr === true) {
                    modalError(alertText);
                }
            } else {
                setActiveButtonPay(false);
                closeModal();
                if (Number(valueInputPoint) > 0) {
                    setMethodPay('point');
                } else if (valueMethod === 'card') {
                    setMethodPay('card');
                } else {
                    setMethodPay('tunai');
                }
            }
        }
    }

    const payNow = (type) => {
        if (methodPay !== undefined) {
            if (usePoint === false) {
                setLoadingPay(true);
                setLoadingAll(true);
                setActiveButtonPay(true);
                sendToPayment(type);
            } else {
                confirm({
                    title: 'Notice',
                    content: 'Apakah Anda yakin ingin menggunakan point untuk pembayaran ini?',
                    onOk() {
                        setLoadingPay(true);
                        setLoadingAll(true);
                        setActiveButtonPay(true);
                        sendToPayment(type);
                    },
                    onCancel() {
                    }
                });
            }
        } else {
            modalError('Pilih Metode Pembayaran');
        }

    };

    const sendToPayment = (type) => {
        const outlet = location.state.item.outlet;
        let payment = 0;

        // Tentukan nilai payment berdasarkan metode pembayaran dan penggunaan poin
        if (methodPay === 'card' || methodPay === 'card_point') {
            payment = grandTotal;
        } else {
            payment = pay !== undefined ? pay : 0;
        }

        // Periksa apakah payment cukup untuk menutupi grandTotal atau poin digunakan
        if (Number(payment) >= grandTotal || usePoint) {
            let point_redeem = 0;
            let point = 0;
            let grand_total = grandTotal;

            // Jika menggunakan poin, tentukan jumlah poin yang diredeem
            if (usePoint) {
                point_redeem = Number(valueInputPoint);
            }

            // Hitung poin pelanggan berdasarkan metode pembayaran
            if (cashbackPoint > 0) {
                point = cashbackPoint;
            }

            // Hitung cashback
            var cashback = 0;
            if (grand_total > 0) {
                cashback = Number(payment) - grand_total;
            }
            var voucher_price = voucherPrice;
            let editNotes = [];
            let minPurchaseNotes = [];
            let clearanceNotes = [];

            productCart.forEach((item) => {
                if (item.edit_price !== undefined) {
                    const hargaNormal = posPriceBeforeDiscountNum(item);

                    editNotes.push(
                        `${item.product.product_name} (Harga normal: ${currencyFormat(hargaNormal)}, Harga jual: ${currencyFormat(item.edit_price)})`
                    );
                }
            });

            productCart.forEach((item) => {
                if (item.is_clearance === true) {
                    const productName =
                        item.product?.product_name ||
                        item.product_name ||
                        item.variant_name ||
                        item.SKU;

                    clearanceNotes.push(
                        `${productName} x${item.qty} @ ${currencyFormat(item.price_clearance || item.edit_price || item.price)}`
                    );
                }
            });

            minPurchaseCart.forEach((item) => {
                minPurchaseNotes.push(
                    `${item.product?.product_name || item.variant_product?.SKU || '-'} x${item.qty || 1} @ ${currencyFormat(item.price)}`
                );
            });

            let finalNotes = note || '';

            if (editNotes.length > 0) {
                finalNotes += `\nPerubahan Harga:\n${editNotes.join('\n')}`;
            }

            if (minPurchaseNotes.length > 0) {
                finalNotes += `\nTebus Murah:\n${minPurchaseNotes.join('\n')}`;
            }

            if (clearanceNotes.length > 0) {
                finalNotes += `\nClearance:\n${clearanceNotes.join('\n')}`;
            }
            // Persiapkan data transaksi
            const data = {
                customer_id: valueCustomer ? valueCustomer.customer_id : null,
                name: valueCustomer ? valueCustomer.name : null,
                phone: valueCustomer ? valueCustomer.phone : null,
                voucher_price: voucher_price,
                outlet_id: Number(outlet.outlet_id),
                outlet_code: outlet.outlet_code,
                outlet_name: outlet.outlet_name,
                branch_name: outlet.branch_name,
                grand_total: grand_total,
                payment: payment,
                payment_method: methodPay,
                card_number: cardNumber,
                cashback: cashback,
                point: point,
                point_redeem: point_redeem,
                product: [],
                // notes: note,
                notes: finalNotes,
                is_ecommerce: isEcommerce,
                transaction_voucher: [],
                user_sell: outlet.user_sell
            };

            if (usedVouchers) {
                if (usedVouchers.length > 0) {
                    for (let i = 0; i < usedVouchers.length; i++) {
                        const ev = usedVouchers[i];
                        data.transaction_voucher.push({
                            voucher_id: ev.voucher_id,
                            voucher_code: ev.voucher_code,
                        })
                    }
                }
            }
            // Tambahkan informasi pembayaran tambahan berdasarkan metode pembayaran
            if (['tunai_point', 'tunai', 'point'].includes(methodPay) && kasPay) {
                data.payment_name = kasPay.name;
                data.payment_id = kasPay.id;
            }

            if (['card_point', 'card'].includes(methodPay) && paymentMethod) {
                data.payment_name = paymentMethod.name;
                data.payment_id = paymentMethod.id;
            }

            // Proses item dalam keranjang produk
            const allCart = [...productCart, ...minPurchaseCart];


            allCart.forEach((item, index) => {
                const isMinPurchase = item.is_min_purchase === true;

                let subtotal = 0;
                let prices = 0;
                let discount = null;
                let is_edit = false;
                let desc_edit = null;
                let points = 0;
                let statusPromo = false;
                let productPromoId = null;

                if (isMinPurchase) {
                    prices = Number(item.price || 0);
                    subtotal = prices * Number(item.qty || 1);
                } else {
                    const activePromo = Array.isArray(item.product_promos)
                        ? item.product_promos.find(isPromoActive)
                        : null;

                    statusPromo = Boolean(activePromo);
                    productPromoId = statusPromo ? activePromo.product_promo_id : null;

                    subtotal = Number(posPriceNum(item, isEcommerce)) * Number(item.qty || 1);
                    prices = posPriceBeforeDiscountNum(item);

                    if (item.statusBonus === undefined) {
                        if (item.edit_price !== undefined) {
                            subtotal = Number(item.edit_price) * Number(item.qty || 1);

                            const discount_price = prices > item.edit_price ? prices - item.edit_price : 0;
                            const dPercent = item.edit_discount_percent || 0;

                            prices = Number(item.edit_price) + Number(discount_price);
                            desc_edit =
                                'Telah merubah data ' +
                                item.product.product_name +
                                ' dari harga ' +
                                posPriceDiscount(item, isEcommerce) +
                                ' ke ' +
                                currencyFormat(item.edit_price);

                            is_edit = true;

                            discount = {
                                discount_percent: dPercent,
                                discount_percent_2: 0,
                                discount_price: discount_price,
                                price_after_discount: item.edit_price,
                            };
                        } else {
                            discount = {
                                discount_percent: posPriceDiscountPercentNum(item, 1, isEcommerce),
                                discount_percent_2: posPriceDiscountPercentNum(item, 2, isEcommerce),
                                discount_price: posPriceDiscountPrice(item, isEcommerce),
                                price_after_discount: posPriceNum(item, isEcommerce),
                            };
                        }
                    }

                    if (valueCustomer !== null && cashbackMemberPoint.length > 0 && cashbackMemberPoint[index]) {
                        const pointStatus = cashbackMemberPoint[index].status;
                        const pointProd = Number(cashbackMemberPoint[index].point);

                        if (pointStatus === 'percent') {
                            points = Number(subtotal) * (pointProd / 100);
                        } else if (pointStatus === 'price') {
                            points = Number(item.qty || 1) * pointProd;
                        }
                    }
                }

                if (isMinPurchase) {
                    prices = Number(item.price || 0);
                    subtotal = prices * Number(item.qty || 1);
                }

                data.product.push({
                    product_id: Number(item.product_id),
                    product_code: item.product?.product_code || item.product_code,
                    variant_product_id: Number(item.variant_product_id),
                    qty: Number(item.qty || 1),
                    bonus_id: item.bonus_id,
                    image: item.image || item.variant_product?.image || item.product?.image,
                    product_name: item.product?.product_name || item.variant_product?.SKU || '-',
                    price: prices,
                    subtotal: Number(subtotal),
                    warehouse_id: outlet.warehouse_id,
                    status_bonus: item.statusBonus,
                    warehouse_name: outlet.warehouse_name,
                    discount: discount,
                    is_edit,
                    desc_edit,
                    is_status_promo: statusPromo,
                    product_promo_id: productPromoId,
                    point: points,
                    is_min_purchase: isMinPurchase,
                    min_purchase_item_id: item.min_purchase_item_id || null,
                    min_purchase_product_id: item.min_purchase_product_id || null,
                    is_clearance: item.is_clearance || null,
                    clearance_product_id: item.clearance_product_id || null,
                });
            });
            // Persiapkan data untuk pencetakan
            const data_print = {
                product: allCart,
                customer: valueCustomer,
                cashier: JSON.parse(user),
                outlet: outlet,
                payment_method: methodPay,
                data: data,
            };

            // setActiveButtonPay(false);
            // setLoadingPay(false);
            // setLoadingAll(false);

            // if (serialPort !== null) {
            //     writePrint(serialPort, data_print);
            // }
            // setTotalQty(0);
            // setDataPrint(data_print);
            // setPaymentMethod(null);
            // setModalDone(true);
            // removeState();

            // Panggil API berdasarkan tipe transaksi
            // type === 'accurate' &&
            if (isSendAccurate == true) {
                callApi('POST', '/transaction/pos', 'transaction', data, null, data_print);
            } else {
                callApi('POST', '/transaction/pos/noaccurate', 'transactionnoaccurate', data, null, data_print);
            }
        } else {
            // Jika payment tidak mencukupi, tampilkan pesan error
            modalError('Nominal Pembayaran lebih kecil dari Total Pembayaran');
            setLoadingPay(false);
            setActiveButtonPay(false);
            setLoadingAll(false);
        }
    };

    const TryPrint = (item) => {
        var data_print = {
            product: item,
            customer: item.customer,
            cashier: item.user,
            outlet: item.outlet,
            payment_method: item.payment_method,
        }
        if (serialPort !== null) {
            writePrintHistory(serialPort, data_print);
        }
    }

    const SelectedItemByScan = (ev) => {
        const split = ev.split('-');
        if (split[0] === 'Membership') {
            const phone = split[split.length - 1];
            callApi('PUT', 'verifypointcustomer', 'customerScan', { phone: phone });
        } else {
            var outlet = location.state.item.outlet;
            callApi('GET', '/productvariant?outletId=' + outlet.outlet_id + '&branchId=' + outlet.branch_id + '&barcode=' + ev, 'checkBarcode');
        }
    }

    // const props = {
    //     name: 'file',
    //     headers: {
    //         'Authorization': 'Bearer ' + token
    //     },
    //     multiple: true,
    //     action: 'https://pos-api.boldestore.com/api/transaction/receipt?transaction_id=' + transactionId,
    //     onChange(info) {
    //         const { status } = info.file;
    //         if (status === 'done') {
    //             message.success(`${info.file.name} file uploaded successfully.`);
    //             removeState();
    //             modalSuccess('File Telah Terkirim');
    //         } else if (status === 'error') {
    //             message.error(`${info.file.name} file upload failed.`);
    //         }
    //     },
    //     onDrop(e) {
    //         console.log('Dropped files', e.dataTransfer.files);
    //     },
    // };

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img.originFileObj);
    };

    const SendUploadReceipt = () => {
        const form = new FormData();
        form.append('file', imageReceiptFile);
        var header = {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'multipart/form-data',
        }
        callApi('POST', '/transaction/receipt?transaction_id=' + transactionId, 'uploadReceipt', form, header);
    }

    const onUploadReceipt = (info) => {
        setImageReceiptFile(info.file.originFileObj);
        getBase64(info.file, (url) => {
            setImageReceiptUrl(url);
        });
    }

    function createOption(name, multiplier) {
        return { name, multiplier };
    }

    function createPrice(basePrice, options) {
        return {
            basePrice,
            options,
        };
    }

    function calculateTotalPrice(basePrice, options, roundingMultiplier) {
        return options.map(option => ({
            name: option.name,
            totalPrice: Math.ceil((basePrice * option.multiplier) / roundingMultiplier) * roundingMultiplier
        }));
    }

    const changeInputPoint = (value) => {
        if (valueCustomer !== null) {
            if (value > Number(valueCustomer.point)) {
                modalError("Point Member melebihi " + valueCustomer.point);
            } else {
                setValueInputPoint(value);
            }
        } else {
            modalError("Belum ada member")
        }
    }

    const grandTotalCurrencyValue = ({
        grand_total = null,
        voucher_value = [],
        point = null,
        point_value = null,
        total = null,
        use_point = null,
        product_cart = null,
        min_purchase_cart = null,
        use_voucher = null,
        payment_method = null
    }) => {
        let total_diskon = 0;
        let grandTotals = grand_total ?? grandTotal;
        let voucherData = voucher_value.length > 0 ? voucher_value : usedVouchers;
        let payMethod = payment_method ?? paymentMethod;
        let pointPrice = point_value?.point ?? point ?? valueInputPoint;
        let cekUsePoint = use_point ?? usePoint;
        let cart = product_cart ?? productCart;
        let minCart = min_purchase_cart ?? minPurchaseCart;
        let useVouchers = use_voucher ?? useVoucher;

        let total_product_price = cart.reduce((acc, item) => {
            let item_price = item.edit_price !== undefined
                ? Number(item.edit_price)
                : Number(posPriceNum(item, isEcommerce));

            return acc + (item_price * Number(item.qty || 1));
        }, 0);

        let total_min_purchase = minCart.reduce((acc, item) => {
            return acc + (Number(item.price) * Number(item.qty || 1));
        }, 0);

        let totalPrices = total_product_price + total_min_purchase;

        if (Number(valueInputPoint) > 0) {
            pointPrice = Number(valueInputPoint);
        }

        if (cekUsePoint) {
            if (Number(pointPrice) > totalPrices) {
                grandTotals = 0;
                setValueInputPoint(totalPrices);
            } else {
                grandTotals = totalPrices - Number(pointPrice);
            }
        } else {
            grandTotals = totalPrices;

            if (useVouchers && voucherData && voucherData.length > 0) {
                voucherData.forEach((vcp) => {
                    if (vcp?.is_discount && Number(totalPrices) > Number(vcp.min_buy)) {
                        if (vcp.category_id !== null) {
                            let total_price_sale = 0;

                            cart.forEach((item) => {
                                if (item.product.category_id === vcp.category_id) {
                                    if (item.edit_discount_percent !== undefined && item.edit_discount_percent !== null) {
                                        total_price_sale = 0;
                                    } else {
                                        let price_normal = Math.round(posPriceBeforeDiscountNum(item));
                                        let prod_discount_price_prod = (price_normal * Number(vcp.discount_percent)) / 100;
                                        let prod_price_sale = price_normal - prod_discount_price_prod;

                                        item.edit_price = prod_price_sale;
                                        item.edit_discount_percent = vcp.discount_percent;
                                        item.edit_discount_price = prod_discount_price_prod;

                                        total_price_sale += Number(item.qty) * Number(prod_discount_price_prod);
                                    }
                                }
                            });

                            totalPrices -= total_price_sale;
                            setProductCart(cart);
                        } else {
                            total_diskon += (totalPrices * Number(vcp.discount_percent)) / 100;
                        }

                        if (Number(vcp.max_price) > 0 && total_diskon > Number(vcp.max_price)) {
                            total_diskon = Number(vcp.max_price);
                        }
                    } else if (vcp?.is_price) {
                        total_diskon += Number(vcp.discount_price);
                    }
                });

                grandTotals = totalPrices - total_diskon;
            } else {
                grandTotals = totalPrices;
            }

            setVoucherPrice(total_diskon);
        }

        if (grandTotals < 0) {
            grandTotals = 0;
        }

        setTotalPrice(totalPrices);
        setUseVoucher(useVouchers);

        handleSubmitDisplay(
            grandTotals,
            [...cart, ...minCart],
            total_diskon,
            pointPrice,
            voucherData,
            cekUsePoint,
            useVouchers,
            payMethod
        );

        setGrandTotal(grandTotals);
    };

    const checkVoucher = () => {
        const existingVoucher = usedVouchers.find(v => v.voucher_code === voucherText);
        if (existingVoucher) {
            modalError('Voucher Sedang Dipakai : ' + voucherText);
        } else {
            callApi('GET', '/voucher?code=' + voucherText, 'voucher');
        }
    }

    const delVoucher = (code) => {
        var row = productCart;
        var voucherDel = usedVouchers.find(v => v.voucher_code === code);
        var grand_total = grandTotal;
        if (voucherDel.category_id !== null) {
            for (let i = 0; i < row.length; i++) {
                if (voucherDel !== null && row[i].product.category_id === voucherDel.category_id) {
                    grand_total += Number(row[i].qty) * row[i].edit_discount_price;
                    delete row[i].edit_price;
                    delete row[i].edit_discount_percent;
                    delete row[i].edit_discount_price;
                }
            }
        } else {
            grand_total += Number(voucherDel.discount_price)
        }
        var fVoucher = usedVouchers.filter(v => v.voucher_code !== code);
        setUsedVouchers(fVoucher);
        if (valueCustomer !== null) {
            if (Number(valueInputPoint) > totalPrice) {
                setGrandTotal(0);
            } else {
                const hsl = totalPrice - Number(valueInputPoint);
                setGrandTotal(hsl);
            }
        } else {
            setGrandTotal(grand_total);
        }
        setProductCart(row);
        grandTotalCurrencyValue({ use_voucher: fVoucher.length > 0 ? true : false, voucher_value: fVoucher });
    }

    const resetInputs = (ev) => {
        setValueInputPoint(0);
        if (ev === "1") {
            setUseVoucher(false);
            setVoucherText(null);
            grandTotalCurrencyValue({ point_value: valueCustomer, use_voucher: false, use_point: false });
        } else {
            setUsePoint(false);
            setStatusEditPoint(false);
            grandTotalCurrencyValue({ total: totalPrice, use_voucher: false, use_point: false });
        }
    };

    const onSavePoint = () => {
        grandTotalCurrencyValue({ point: valueInputPoint, use_point: true });
        setStatusEditPoint(false);
    }

    const onChangeUsePoint = (ev) => {
        setUsePoint(ev);
        grandTotalCurrencyValue({ point_value: valueCustomer, use_point: ev });
    }

    const handleSubmitDisplay = async (gTotal, pCart, voucher, pointPrice, vcp, cekUsePoint, useVoucher, payment_method) => {
        const state = location.state;
        const outletId = state.item.outlet.outlet_id;
        const point = pointPrice;
        const newTransactions = pCart != null ? pCart : productCart;
        const newTotal = gTotal;
        socket.emit('newTransaction', {
            transactions: newTransactions,
            total: newTotal,
            outletId,
            voucher,
            point,
            vcp,
            pay: false,
            usePoint: cekUsePoint,
            useVoucher: useVoucher,
            payment_method
        });
    };

    const saveDetailProduct = async (ev) => {
        var row = productCart;
        const originalPrice = posPriceBeforeDiscountNum(productCart[indexDetailProduct]);
        if (originalPrice > ev.price_sale) {
            if (row[indexDetailProduct].edit_price !== undefined) {
                row[indexDetailProduct].edit_price_before = row[indexDetailProduct].edit_price;
            }
            row[indexDetailProduct].edit_price = ev.price_sale;
            const newPriceSale = parseFloat(ev.price_sale);
            const newDiscount = ((originalPrice - newPriceSale) / originalPrice) * 100;
            row[indexDetailProduct].edit_discount_percent = Math.round(newDiscount);
        } else {
            row[indexDetailProduct].edit_price = ev.price_sale;
        }
        updateQty(row[indexDetailProduct], indexDetailProduct, 'edit');
        closeModal();
        formDetailProduct.resetFields();
    }

    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowFeatures = `width=${screenWidth},height=${screenHeight},left=${screenWidth},top=0`;

    const changePriceByStatus = async (ev) => {
        setIsEcommerce(ev)
    }

    const downloadInvoicePDF = async (transaction_code) => {
        const downloadUrl = `https://pos-api.boldestore.com/api/sendreceipt?transaction_code=${transaction_code}`;
        window.open(downloadUrl, '_blank');
    };

    const checkCashBackPointMember = (cart = null, customer = null) => {
        const state = location.state;
        if (customer !== null) {
            setLoading(true);
            if (cart == null) {
                cart = productCart;
            }
            var arr = [];
            var gt = 0;
            for (let i = 0; i < cart.length; i++) {
                const item = cart[i];
                arr.push({ product_id: item.product_id });
                if (cart[i].edit_price !== undefined) {
                    gt += Number(cart[i].edit_price) * Number(item.qty);
                } else {
                    gt += Number(posPriceNum(item, isEcommerce)) * Number(item.qty);
                }
            }
            const data = {
                product: arr,
                outletId: state.item.outlet.outlet_id,
                grand_total: gt
            }
            callApi('POST', '/memberdisc/active', 'checkCashbackMember', data, null, cart);
        } else {
            setValueCustomer(null);
            setCashbackPoint(0);
            setCashbackMemberPoint([]);
        }
    }



    return (
        <div>
            <BarcodeReader
                onScan={SelectedItemByScan}
                onError={SelectedItemByScan}
            />
            {
                location.state != null &&
                <Row style={{ marginBottom: 5, marginTop: -15 }}>
                    <Col span={12}>
                        <b style={{ marginRight: 25 }}>{location.state.item.outlet.outlet_name}</b>
                        <Switch onChange={(ev) => changePriceByStatus(ev)} checked={isEcommerce} checkedChildren="Ecommerce" unCheckedChildren="POS" />
                        <Tag
                            color={isEcommerce ? "green" : "blue"}
                            style={{ marginLeft: 8 }}
                        >
                            {isEcommerce ? "Harga Ecommerce Aktif" : "Harga Pos Aktif"}
                        </Tag>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: "flex-end", paddingRight: 10 }}>
                        <Button onClick={() => window.open(`/#/display/${location.state.item.outlet.outlet_id}`, '_blank', windowFeatures)} type='primary' style={{ fontWeight: "bold" }}>Show Display</Button>
                    </Col>
                </Row>
            }
            <Divider style={{ margin: 0, marginBottom: 10 }} />
            <Spin spinning={loadingAll}>
                <Row>
                    <Col span={16}>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={16}>
                                <Search
                                    placeholder="Pencarian"
                                    allowClear
                                    size="medium"
                                    onChange={(e) => searchdata(e.target.value, 'product')}
                                />
                                <List
                                    grid={{
                                        gutter: 10,
                                        xs: 4,
                                        sm: 4,
                                        md: 4,
                                        lg: 4,
                                        xl: 4,
                                        xxl: 4,
                                    }}
                                    dataSource={selectPromo}
                                    renderItem={(item, index) => (
                                        <List.Item>
                                            <Button
                                                style={{
                                                    marginTop: 10,
                                                    textAlign: "center",
                                                    height: 40,
                                                    padding: 0,
                                                    lineHeight: 0
                                                }}
                                                block
                                                type={item.status === true ? "primary" : "default"}
                                                onClick={() => searchPromoProduk(index)}>
                                                <b style={{ fontSize: 12 }}>{item.label}</b>
                                            </Button>
                                        </List.Item>
                                    )}
                                />
                            </Col>
                            {/* <Col span={6}> */}
                            <Col span={8}>
                                <Row>
                                    <Col span={24} style={{ textAlign: "center", paddingLeft: 10, paddingRight: 10 }}>
                                        <Button block type="primary" onClick={() => openModal('category')}>
                                            <b style={{ marginLeft: 5 }}>Kategori</b>
                                        </Button>
                                    </Col>
                                    {/* <Col span={12} style={{ textAlign: "center", paddingRight: 10 }}>
                                        <Button block type="primary" onClick={() => openModal('membership')}>
                                            <b style={{ marginLeft: 5 }}>Membership</b>
                                        </Button>
                                    </Col> */}
                                </Row>
                                {
                                    valueCustomer != null &&
                                    <div style={{ position: 'relative', textAlign: 'center', margin: 10, padding: 0, border: '1px solid #CCC', borderRadius: 5 }}>
                                        <p style={{ fontSize: 11, margin: '10px 0' }}>{valueCustomer.name}</p>
                                        <Button
                                            type='text'
                                            style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)' }}
                                            onClick={() => {
                                                setValueCustomer(null);
                                                setValueInputPoint(0);
                                                checkCashBackPointMember(null, null);
                                            }}
                                        >
                                            <CloseOutlined style={{ color: '#FF4500' }} />
                                        </Button>
                                    </div>
                                }
                            </Col>
                        </Row>
                        <div id="scrollableDiv" style={{ height: '64vh', overflowY: 'scroll', marginRight: 10 }} >

                            <InfiniteScroll
                                dataLength={product.length}
                                next={loadMoreData}
                                hasMore={valuePromo !== 'clearance' && product.length < page.total_page}
                                scrollableTarget="scrollableDiv"
                            >
                                <List
                                    loading={loading}
                                    grid={{
                                        gutter: 10,
                                        xs: 1,
                                        sm: 2,
                                        md: 3,
                                        lg: 4,
                                        xl: 4,
                                        xxl: 4,
                                    }}
                                    style={{
                                        marginRight: 10
                                    }}
                                    // loading={!loading}
                                    dataSource={product}
                                    renderItem={(item, index) => (
                                        <List.Item onClick={() => updateProdukCart(item, index)}>
                                            <Card style={{
                                                textAlign: "center",
                                            }}>
                                                {
                                                    posPriceDiscountPercentNum(item, 1, isEcommerce) > 0 ?
                                                        <div>
                                                            <div style={{
                                                                backgroundColor: "#DC143C",
                                                                color: "#FFF",
                                                                marginTop: -25,
                                                                position: 'absolute',
                                                                borde: 4,
                                                                borderBottomLeftRadius: 20,
                                                                height: 30,
                                                                width: 80,
                                                                zIndex: 2,
                                                                textAlign: 'center',
                                                                paddingTop: 7,
                                                                fontSize: 10,
                                                                right: 0
                                                            }}>
                                                                <b>Promo</b>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    item.product_packages != null &&
                                                        item.product_packages.length > 0 ?
                                                        <div>
                                                            <div style={{
                                                                backgroundColor: "#008B8B",
                                                                color: "#FFF",
                                                                marginTop: -25,
                                                                position: 'absolute',
                                                                borde: 4,
                                                                borderBottomLeftRadius: 20,
                                                                height: 30,
                                                                width: 80,
                                                                zIndex: 2,
                                                                textAlign: 'center',
                                                                paddingTop: 7,
                                                                fontSize: 10,
                                                                right: 0
                                                            }}>
                                                                <b>Bonus</b>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                <Image
                                                    preview={false}
                                                    src={item.image != null ? urlProduct + item.image : '/assets/photo_empty.png'}
                                                    fallback="data:image/png;base64,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"
                                                />
                                                <p style={{ fontSize: 10, textAlign: "center" }}>{item.product.product_name} {item.variant_name !== '' ? item.variant_name : null}</p>
                                                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                                                    {
                                                        posPriceDiscountPercentNum(item, 1, isEcommerce) > 0 ?
                                                            <div style={{
                                                                marginLeft: -24
                                                            }}>
                                                                <div style={{
                                                                    backgroundColor: "#d6006e",
                                                                    color: "#FFF",
                                                                    // width: 35,
                                                                    padding: 2,
                                                                    marginRight: 5,
                                                                    paddingLeft: 5,
                                                                    paddingRight: 5,
                                                                    borderRadius: 5,
                                                                    textAlign: 'center',
                                                                    fontSize: 10,
                                                                }}>
                                                                    <b>{posPriceDiscountPercent(item, isEcommerce)}</b>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    {posPriceDiscountPercentNum(item, 1, isEcommerce) > 0 && <p style={{ fontSize: 11, textAlign: "center", color: "#666", textDecorationLine: 'line-through' }}>{posPriceBeforeDiscount(item)}</p>}
                                                </Row>
                                                <p style={{ fontSize: 12, textAlign: "center", color: "#FF4500" }}>{posPriceDiscount(item, isEcommerce)}</p>
                                            </Card>
                                        </List.Item>
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div style={{
                            border: '1px solid #CCC',
                            height: usePoint === true ? '55vh' : voucherPrice > 0 ? '55vh' : '61vh',
                            overflowY: 'hidden',
                        }}>
                            <Row align="middle">
                                <Col span={8}>
                                    <p style={{ marginLeft: 10, fontSize: 12 }}>Cart Detail</p>
                                </Col>
                                <Col span={8} style={{ display: 'flex', justifyContent: "center", paddingRight: 10 }}>
                                    <b style={{ fontSize: 15 }}>Qty : {totalQty}</b>
                                </Col>
                                <Col span={8} style={{ display: 'flex', justifyContent: "flex-end", paddingRight: 10 }}>
                                    <Space size="middle">
                                        <Button style={{ margin: 0, padding: 0, border: 0 }} type='default' onClick={() => openModal('hold')}>
                                            <Badge size="small" count={listHoldTransakasi.length}>
                                                <ShoppingCartOutlined />
                                            </Badge>
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                            <Divider style={{ margin: 0 }} />
                            <div style={{ height: usePoint === true ? '49vh' : voucherPrice > 0 ? '49vh' : '55vh', overflowY: 'scroll' }}>
                                <List
                                    loading={loading}
                                    dataSource={productCart}
                                    renderItem={(item, index) => (
                                        <div>
                                            {
                                                item.statusBonus === true || item.statusTransBonus === true ?
                                                    <List.Item >
                                                        <Row align="middle">
                                                            <Col span={3}>
                                                                <Image preview={false} src={'/assets/bonus.png'} />
                                                            </Col>
                                                            <Col span={3}>
                                                                <Image
                                                                    preview={false}
                                                                    src={item.image != null ? urlProduct + item.image : '/assets/photo_empty.png'}
                                                                    fallback="data:image/png;base64,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"
                                                                />
                                                                {/* <div  style={{padding:10,borderRadius:10,borderWidth:1}}>
                                                                {index+1}
                                                            </div> */}
                                                            </Col>
                                                            <Col span={12}>
                                                                <b style={{ fontSize: 10 }}>{item.product.product_name} {item.variant_name !== '' ? item.variant_name : null}</b><br />
                                                            </Col>
                                                            <Col span={6} >
                                                                <b style={{ fontSize: 9 }}>Bonus {item.qty} {item.product.product_satuans[0].satuan !== null ? item.product.product_satuans[0].satuan : 'pcs'}</b>
                                                            </Col>
                                                        </Row>
                                                    </List.Item>
                                                    :
                                                    <List.Item >
                                                        <Row align="middle" style={{ width: '100%' }}>
                                                            <Col span={4} >
                                                                <div style={{ margin: 10 }}>
                                                                    <div style={{
                                                                        border: '3px solid #d6006e',
                                                                        color: "#d6006e",
                                                                        fontWeight: "bold",
                                                                        fontSize: 20,
                                                                        borderRadius: 10,
                                                                        height: "auto",
                                                                        width: "100%",
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        textAlign: "center",
                                                                        // verticalAlign:
                                                                    }}>
                                                                        {index + 1}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col span={12} 
                                                            onClick={() => {
                                                                setIndexDetailProduct(index);
                                                                setModalDetailProduct(true);
                                                            }}
                                                            >
                                                                <b style={{ fontSize: 12 }}>{item.product.product_name} {item.variant_name !== '' ? item.variant_name : null}</b>
                                                                <Row style={{ justifyItems: "center", textAlign: "center", }} >
                                                                    {
                                                                        item.edit_discount_percent !== undefined ?
                                                                            <div style={{ backgroundColor: "#d6006e", height: 15, paddingRight: 10, paddingLeft: 10, textAlign: "center", borderRadius: 5, marginRight: 10 }}>
                                                                                <div style={{ fontWeight: "bold", fontSize: 10, color: "#FFF", textAlign: "center", }}>{item.edit_discount_percent}%</div>
                                                                            </div>
                                                                            :
                                                                            posPriceDiscountPercentNum(item, 1, isEcommerce) > 0 ?
                                                                                <div style={{ backgroundColor: "#d6006e", height: 15, paddingRight: 10, paddingLeft: 10, textAlign: "center", borderRadius: 5, marginRight: 10 }}>
                                                                                    <div style={{ fontWeight: "bold", fontSize: 10, color: "#FFF", textAlign: "center", }}>{posPriceDiscountPercent(item, isEcommerce)}</div>
                                                                                </div>
                                                                                :
                                                                                null
                                                                    }
                                                                    <div style={{ fontSize: 10, color: "#FF4500" }}>{item.edit_price !== undefined ? currencyFormat(item.edit_price) : posPriceDiscount(item, isEcommerce)}</div>
                                                                </Row>

                                                                {item.is_clearance === true && (
                                                                    <Tag color="orange">
                                                                        Clearance
                                                                    </Tag>
                                                                )}
                                                            </Col>
                                                            <Col span={6} style={{ alignContent: "center" }} >
                                                                <Row>
                                                                    <Button onClick={() => updateQty(item, index, 'add')} type="primary" style={{ margin: 0, padding: 0, height: 25, width: 25, alignSelf: "center" }} >
                                                                        <PlusOutlined />
                                                                    </Button>
                                                                    <p style={{ fontSize: 12, marginRight: 10, marginLeft: 10 }}>{item.qty}</p>
                                                                    <Button onClick={() => updateQty(item, index, 'min')} type="primary" style={{ margin: 0, padding: 0, height: 25, width: 25, alignSelf: "center" }} >
                                                                        <MinusOutlined />
                                                                    </Button>
                                                                </Row>
                                                            </Col>
                                                            <Col span={2} >
                                                                <Button style={{ margin: 0, padding: 0, border: 0 }} type='default' onClick={() => updateQty(item, index, 'del')}>
                                                                    <CloseOutlined color='#FF4500' />
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </List.Item>
                                            }
                                            {/* {
                                        item.bonus !== undefined && item.bonus !== null ?
                                            item.qty >= item.bonus.min_order ?
                                                item.bonus.bonus_product !== null ?
                                                    <List.Item >
                                                        <Row align="middle">
                                                            <Col span={3}>
                                                                <Image preview={false} src={'/assets/bonus.png'} />
                                                            </Col>
                                                            <Col span={3}>
                                                                <Image preview={false} src={item.bonus.bonus_product.variant_product.image != null ? urlProduct + item.bonus.bonus_product.variant_product.image : '/assets/photo_empty.png'}
                                                                    fallback="data:image/png;base64,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"
                                                                />
                                                            </Col>
                                                            <Col span={12}>
                                                                <b style={{ fontSize: 9 }}>{item.bonus.bonus_product.variant_product.product.product_name + " " + item.bonus.bonus_product.variant_product.variant_name}</b>
                                                                <p style={{ fontSize: 8, color: "#FF4500" }}>{currencyFormat(0)}</p>
                                                            </Col>
                                                            <Col span={6} >
                                                                <b style={{ fontSize: 9 }}>Bonus {bonusPCS(item) + ' ' + item.bonus.bonus_product.variant_product.product.product_satuan.satuan}</b>
                                                            </Col>
                                                        </Row>
                                                    </List.Item>
                                                    :
                                                    null
                                                :
                                                null
                                            :
                                            null
                                    } */}
                                        </div>
                                    )}
                                />

                                {shopMinPromo.length > 0 && (
                                    <Button
                                        block
                                        type="primary"
                                        icon={<ShoppingCartOutlined />}
                                        style={{ marginTop: 10 }}
                                        onClick={() => {
                                            setSearchMinPurchase('');
                                            setModalMinPurchase(true);
                                        }}
                                    >
                                        Produk Tebus Murah Tersedia ({shopMinPromo.reduce((acc, promo) => acc + (promo.min_purchase_items?.length || 0), 0)})
                                    </Button>
                                )}

                                {minPurchaseCart.length > 0 && (
                                    <Card
                                        size="small"
                                        style={{
                                            marginTop: 10,
                                            borderRadius: 8,
                                        }}
                                        title={
                                            <Space>
                                                <ShoppingCartOutlined />
                                                <span>Cart Tebus Murah</span>
                                            </Space>
                                        }
                                    >
                                        <List
                                            size="small"
                                            dataSource={minPurchaseCart}
                                            renderItem={(item) => (
                                                <List.Item
                                                    style={{
                                                        padding: 8,
                                                        marginBottom: 6,
                                                        border: '1px solid #f0f0f0',
                                                        borderRadius: 8,
                                                    }}
                                                    actions={[
                                                        <Button
                                                            type="text"
                                                            danger
                                                            size="small"
                                                            onClick={() => deleteMinPurchaseItem(item)}
                                                        >
                                                            <DeleteOutlined />
                                                        </Button>
                                                    ]}
                                                >
                                                    <List.Item.Meta
                                                        title={
                                                            <div style={{ fontSize: 13 }}>
                                                                {item.product?.product_name || '-'}
                                                            </div>
                                                        }
                                                        description={
                                                            <Space direction="vertical" size={2}>
                                                                <span style={{ fontSize: 12, color: '#888' }}>
                                                                    {item.variant_product?.variant_name || item.variant_product?.SKU || '-'}
                                                                </span>
                                                                <b>{currencyFormat(item.price)}</b>
                                                            </Space>
                                                        }
                                                    />
                                                </List.Item>
                                            )}
                                        />

                                        <Divider style={{ margin: '8px 0' }} />

                                        <Row>
                                            <Col span={12}>
                                                <b>Total Tebus Murah</b>
                                            </Col>
                                            <Col span={12} style={{ textAlign: 'right' }}>
                                                <b>
                                                    {currencyFormat(
                                                        minPurchaseCart.reduce((total, item) => {
                                                            return total + (Number(item.price) * Number(item.qty || 1));
                                                        }, 0)
                                                    )}
                                                </b>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}
                            </div>

                            <div style={{
                                position: 'absolute',
                                left: 0,
                                bottom: 0,
                                right: 0,
                            }}>
                                {
                                    voucherPrice > 0 || usePoint === true ?
                                        <Row style={{ marginTop: 0 }}>
                                            <Col span={12}>
                                                <div style={{ fontSize: 11 }}>Total Belanja</div>
                                            </Col>
                                            <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                <div style={{ fontSize: 11 }}>{currencyFormat(totalPrice)}</div>
                                            </Col>
                                        </Row>
                                        :
                                        null
                                }
                                {
                                    voucherPrice > 0 ?
                                        <div>
                                            <Row style={{ marginTop: 0 }}>
                                                <Col span={12}>
                                                    <div style={{ fontSize: 11 }}>Voucher</div>
                                                </Col>
                                                <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <div style={{ fontSize: 11 }}>{currencyFormat(voucherPrice)}</div>
                                                </Col>
                                            </Row>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    usePoint === true ?
                                        <div>
                                            <Row style={{ marginTop: 0 }}>
                                                <Col span={12}>
                                                    <div style={{ fontSize: 11 }}>Point Member</div>
                                                </Col>
                                                <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <div style={{ fontSize: 11 }}>{currencyFormat(valueInputPoint)}</div>
                                                </Col>
                                            </Row>
                                            <Divider style={{ margin: 0 }} />
                                        </div>
                                        :
                                        null

                                }
                                <Row style={{ marginTop: 5 }}>
                                    <Col span={12}>
                                        <b style={{ fontSize: 20 }}>Grand Total</b>
                                    </Col>
                                    <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <b style={{ fontSize: 20 }}>{currencyFormat(grandTotal)}</b>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: 5 }}>
                                    <Col span={14} style={{ paddingRight: 10 }}>
                                        <Button style={{ height: 40 }} disabled={productCart.length > 0 && loading === false ? false : true} block type="primary" onClick={() => openModal('method')}>
                                            <b style={{ marginLeft: 5 }}>Metode Pembayaran</b>
                                        </Button>
                                    </Col>
                                    <Col span={5} >
                                        <Button style={{ height: 40 }} disabled={productCart.length > 0 ? false : true} block type="default" onClick={() => onHold()}>
                                            <b style={{ marginLeft: 5 }}>Hold</b>
                                        </Button>
                                    </Col>
                                    <Col span={5} style={{ paddingLeft: 10 }}>
                                        <Button style={{ height: 40 }} block type="default" onClick={() => openModal('bill')}>
                                            <b style={{ marginLeft: 5 }}>Bill</b>
                                        </Button>
                                    </Col>
                                </Row>

                                <Button disabled={activeButtonPay} block type="primary" style={{ marginTop: 10, height: 40 }} onClick={() => payNow('accurate')}>
                                    {
                                        loadingPay === true ?
                                            <div>
                                                <Spin />
                                                <b style={{ marginLeft: 5 }}>Loading...</b>
                                            </div>
                                            :
                                            <b style={{ marginLeft: 5 }}>Bayar</b>
                                    }
                                </Button>
                                {/* <Row gutter={10}>
                                    <Col span={12}>
                                        <Button disabled={activeButtonPay} block type="primary" style={{ marginTop: 5 }} onClick={() => payNow('accurate')}>
                                            {
                                                loadingPay === true ?
                                                    <div>
                                                        <Spin />
                                                        <b style={{ marginLeft: 5 }}>Loading...</b>
                                                    </div>
                                                    :
                                                    <b style={{ marginLeft: 5 }}>Bayar</b>
                                            }
                                        </Button>
                                    </Col>
                                    <Col span={12}>
                                        <Button disabled={activeButtonPay} block type="primary" style={{ marginTop: 5, backgroundColor: 'DodgerBlue', textAlign: 'center' }} onClick={() => payNow('no-accurate')}>
                                            {
                                                loadingPay === true ?
                                                    <div>
                                                        <Spin />
                                                        <b style={{ marginLeft: 5 }}>Loading...</b>
                                                    </div>
                                                    :
                                                    <b style={{ marginLeft: 5 }}>Bayar No Post</b>
                                            }
                                        </Button>
                                    </Col>
                                </Row> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>

            <Modal title="Detail Produk" open={modalDetailProduct} onCancel={() => closeModal()} onOk={formDetailProduct.submit} >
                {
                    indexDetailProduct !== null &&
                    <>
                        <b style={{ fontSize: 13 }}>{productCart[indexDetailProduct].product.product_name} {productCart[indexDetailProduct].variant_name !== '' ? productCart[indexDetailProduct].variant_name : null}</b>

                        <p>Harga asli : {posPriceBeforeDiscount(productCart[indexDetailProduct])}</p>
                        <Form
                            form={formDetailProduct}
                            name="form_detail_produk"
                            layout="vertical"
                            onFinish={saveDetailProduct}>
                            <Form.Item
                                name="price_sale"
                                label="Harga Jual"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Harga Jual kosong!'
                                    },
                                ]}
                            >
                                <InputNumber
                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                    style={{ width: '100%' }}
                                    placeholder="Harga Jual"
                                />
                            </Form.Item>
                        </Form>
                    </>
                }
            </Modal>
            <Modal title="Daftar Kategori" open={modalCategory} footer={null} onCancel={() => closeModal()} >
                <Search
                    style={{ marginBottom: 10, marginTop: 10 }}
                    placeholder="Pencarian"
                    allowClear
                    size="medium"
                    onSearch={(value) => searchdata(value, 'category')}
                />

                <List>
                    <VirtualList
                        data={category}
                        height={400}
                        itemHeight={47}
                    // onScroll={onScroll}
                    >
                        {(item) => (
                            <List.Item onClick={() => searchProductBy(item, 'category')}>
                                <div>{item.category_name}</div>
                            </List.Item>
                        )}
                    </VirtualList>
                </List>
            </Modal>
            <Modal title="Membership" open={modalMembership} footer={null} onCancel={() => closeModal()} >
                <Row>
                    <Col span={20}>
                        <Search
                            placeholder="Pencarian"
                            allowClear
                            size="medium"
                            onSearch={(value) => debouncedSearchdata(value, 'customer')}
                        />
                    </Col>
                    <Col span={2}>
                        <Button style={{ marginLeft: 10 }} type="primary" onClick={() => openModal('form_membership')}>
                            <PlusOutlined />
                        </Button>
                    </Col>
                </Row>
                <List loading={loading}>
                    <VirtualList
                        data={customer}
                        height={ContainerHeight}
                        itemHeight={47}
                        itemKey="customer_id"
                        onScroll={(e) => {
                            if (e.target.scrollTop + ContainerHeight >= e.target.scrollHeight) {
                                loadMoreDataCustomer();
                            }
                        }}
                    >
                        {(item) => (
                            <List.Item key={item.customer_id} style={{ display: "inline" }} onClick={() => SelectedCustomer(item)}>
                                <Row align="middle" justify="center">
                                    <Col span={4}>
                                        <Image style={{ borderRadius: 50 }} preview={false} src='/assets/user_blank.png' height={50} width={50} />
                                    </Col>
                                    <Col span={10}>
                                        <div style={{ width: "100%" }}>{item.name}</div>
                                    </Col>
                                    <Col span={10}>
                                        <div style={{ width: "100%" }}>{item.phone}</div>
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    </VirtualList>
                </List>
            </Modal>
            <Modal title="Form Membership" open={modalFormMembership} confirmLoading={loading} onOk={formMembership.submit} okText="Simpan" onCancel={() => setModalFormMembership(false)} >
                <Form form={formMembership} name="form_membership" layout="vertical" onFinish={saveMembership}>
                    <Form.Item
                        name="name"
                        label="Nama Customer"
                        rules={[
                            {
                                required: true,
                                message: 'Nama Customer kosong!'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Nomor Telepon"
                        rules={[
                            {
                                required: true,
                                message: 'Nomor Telepon kosong!'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal title="Metode Pembayaran" open={modalFormMethod} onOk={() => saveMethod()} okText="Pilih" onCancel={() => closeModal()} >
                <Tabs defaultActiveKey="1" onChange={resetInputs}>
                    <TabPane tab="Point Member" key="1">
                        {
                            valueCustomer !== null && <>
                                <Radio.Group style={{ marginBottom: 10 }} onChange={(ev) => onChangeUsePoint(ev.target.value)} value={usePoint}>
                                    <Radio value={true}>Gunakan Point</Radio>
                                    <Radio value={false}>Tidak menggunakan Point</Radio>
                                </Radio.Group>
                                {
                                    usePoint === true &&
                                    <div>
                                        <div>Point Member</div>
                                        <Row>
                                            <Col span={18}>
                                                <InputNumber
                                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                                    style={{ width: '100%' }}
                                                    value={valueInputPoint}
                                                    placeholder="Point Member"
                                                    disabled={!statusEditPoint}
                                                    onChange={(val) => changeInputPoint(val)}
                                                />
                                            </Col>
                                            <Col span={6}>
                                                {
                                                    statusEditPoint === false ?
                                                        <Button onClick={() => setStatusEditPoint(true)} style={{ marginLeft: 10 }} type='primary'>Edit Point</Button>
                                                        :
                                                        <Button onClick={() => onSavePoint()} style={{ marginLeft: 10 }} type='default'>Save Point</Button>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </>
                        }
                    </TabPane>
                    <TabPane tab="Voucher" key="2">
                        <div>Voucher</div>
                        <Row>
                            <Col span={18}>
                                <Input
                                    onChange={(e) => setVoucherText(e.target.value)}
                                    value={voucherText}
                                    placeholder="Masukkan kode voucher"
                                />
                            </Col>
                            <Col span={6}>
                                <Button onClick={checkVoucher} style={{ marginLeft: 10 }} type="primary">
                                    Cek Voucher
                                </Button>
                            </Col>
                        </Row>

                        {/* Tampilkan daftar voucher yang digunakan */}
                        {usedVouchers.length > 0 && (
                            <div style={{ marginTop: 10 }}>
                                {usedVouchers.map((voucher) => (
                                    <div
                                        key={voucher.code}
                                        style={{
                                            border: "1px solid #F2F2F2",
                                            borderRadius: 10,
                                            marginTop: 10,
                                            padding: 10,
                                            borderLeft: "15px solid #D6006E",
                                            borderRight: "5px solid #D6006E",
                                            backgroundColor: "#FFF",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                    >
                                        <div>
                                            <div>{voucher.voucher_code}</div>
                                            <div>
                                                {voucher.voucher_name}
                                                <Tag color="#D6006E" style={{ marginLeft: 10 }}>
                                                    {voucher.is_discount === true ? voucher.discount_percent + '%' : currencyFormat(voucher.discount_price)}
                                                </Tag>
                                            </div>
                                        </div>
                                        <Button type="primary" danger onClick={() => delVoucher(voucher.voucher_code)}>
                                            <DeleteOutlined />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </TabPane>
                </Tabs>

                <div style={{ background: "#F2F2F2", borderRadius: 5, paddingLeft: 15, paddingRight: 5, borderRadius: "10px" }}>
                    <h2 style={{ color: '#555' }}>Grand Total : {currencyFormat(grandTotal)}</h2>
                </div>

                {
                    usePoint === false && cashbackPoint > 0 ?
                        <div
                            style={{
                                backgroundColor: "#F2F2F2",
                                borderRadius: "10px",
                                padding: "10px 15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <h4 style={{ color: "#666", margin: 0, fontSize: "16px" }}>
                                Cashback Point :{" "}
                                <span style={{ fontWeight: "bold", color: "#d6006e" }}>
                                    {currencyFormat(cashbackPoint)}
                                </span>
                            </h4>
                        </div>

                        :
                        null
                }

                <p>Note : </p>
                <TextArea rows={3} onChange={(ev) => setNote(ev.target.value)} placeholder="Tulis Note (Opsional)" />

                <Tabs
                    defaultActiveKey={valueMethod}
                    onChange={(val) => setValueMethod(val)}
                    items={[
                        {
                            label: 'Tunai',
                            key: 'tunai',
                            children: <div>
                                {
                                    kasPay != null && kasPay.id != null ?
                                        <>
                                            <InputNumber
                                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                                style={{ width: '100%' }}
                                                value={pay}
                                                placeholder="Jumlah Bayar"
                                                onChange={(val) => setPay(val)}
                                            />
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6} style={{ paddingRight: 10 }}>
                                                    <Button block type='default' onClick={() => setPay(grandTotal)}>Uang Pas</Button>
                                                </Col>
                                                {
                                                    opsionalPrice.map((key, i) => (
                                                        <Col key={i} span={6} style={{ paddingRight: 10 }}>
                                                            <Button block type='default' onClick={() => setPay(key)}>{currencyFormat(key)}</Button>
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                        </>
                                        :
                                        <Alert message={"Atur Akun Terima Pemabayaran terlebih dahulu"} type="warning" />
                                }
                            </div>,
                        },
                        {
                            label: 'Non Tunai',
                            key: 'card',
                            children: <div>
                                {
                                    listDevicePay !== null && listDevicePay.length > 0 ?
                                        <>
                                            <Input
                                                onChange={(val) => setCardNumber(val.target.value)}
                                                value={cardNumber}
                                                placeholder="Input ID Number Debit"
                                            />
                                            <p>Pilih Perangkat</p>
                                            <Row style={{ marginTop: 10 }}>
                                                {
                                                    listDevicePay.map((key, i) => (
                                                        <Col key={i} span={8} style={{ paddingRight: 10, marginBottom: 10 }}>
                                                            <Button block type={key.status === true ? 'primary' : 'default'} onClick={() => {
                                                                var row = listDevicePay;
                                                                for (let i2 = 0; i2 < row.length; i2++) {
                                                                    row[i2].status = false;
                                                                }
                                                                row[i].status = true;
                                                                setListDevicePay(row);
                                                                setPaymentMethod(key);
                                                            }}>{key.name}</Button>
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                            <br />
                                        </>
                                        :
                                        <Alert message={"Atur Akun Terima Pemabayaran terlebih dahulu"} type="warning" />
                                }
                            </div>
                        }
                    ]}
                />
            </Modal>
            <Modal title="Transaksi Tertunda" open={modalHoldTrans} footer={null} onCancel={() => closeModal()} >
                <List>
                    <VirtualList
                        data={listHoldTransakasi}
                        height={400}
                        itemHeight={47}
                    >
                        {(item, index) => (
                            <List.Item onClick={() => showHoldToProductCart(item, index)}>
                                <div>Transaksi {item.date_hold}</div>
                            </List.Item>
                        )}
                    </VirtualList>
                </List>
            </Modal>
            <Modal width={1000} title="Daftar Bill" open={modalBill} footer={null} onCancel={() => closeModal()} >
                <Search
                    style={{ width: 400, marginTop: 10, marginBottom: 10 }}
                    placeholder="Pencarian"
                    allowClear
                    enterButton="Search"
                    size="medium"
                    onSearch={(value) => debouncedSearchdata(value, 'transaction')}
                />
                {
                    listBill.length > 0 ?

                        <InfiniteScroll
                            dataLength={listBill.length}
                            next={loadMoreDataBill}
                            hasMore={listBill.length < pageBill.total_page}
                        >
                            <List>
                                <VirtualList
                                    data={listBill}
                                    height={500}
                                    itemHeight={47}
                                >
                                    {(item, index) => (
                                        <List.Item key={index} style={{ display: "inline" }} >
                                            <Row align="middle" justify="center">
                                                <Col span={8}>
                                                    <div style={{ fontSize: 12 }}>{item.transaction_code}</div>
                                                    <div style={{ fontSize: 12 }}>{item.device_payment}</div>
                                                    <div style={{ fontSize: 12 }}>{dateFormat(new Date(item.created_at))}</div>
                                                </Col>
                                                <Col span={7}>
                                                    {item.customer != null && <div style={{ fontSize: 12 }}>{item.customer.name}</div>}
                                                    {/* <div style={{ fontSize: 12 }}>{item.total_qty} Produk</div> */}
                                                    <div style={{ fontSize: 12 }}>{currencyFormat(Number(item.grand_total))}</div>
                                                </Col>
                                                <Col span={7}>
                                                    <Button style={{ marginRight: 5 }} onClick={() => TryPrint(item)}>
                                                        <div style={{ fontSize: 12 }}><PrinterOutlined /></div>
                                                    </Button>
                                                    <Button style={{ marginRight: 5 }} disabled={loading} onClick={() => downloadInvoicePDF(item.transaction_code)}>
                                                        <div style={{ fontSize: 12 }}>{loading === true ? <Spin /> : <FilePdfOutlined />}</div>
                                                    </Button>
                                                    {/* {
                                                        item.customer !== null && item.point !== null &&
                                                        <>
                                                            {
                                                                item.file_receipt !== null ?
                                                                    item.point.status === 'Process' ?
                                                                        <Button type='ghost' style={{ fontSize: 12, color: "orange" }}>Sedang Diverifikasi oleh Admin</Button>
                                                                        :
                                                                        item.point.status === 'Approved' ?
                                                                            <Button type='ghost' style={{ fontSize: 12, color: "green" }}>Verifikasi Telah Disetujui</Button>
                                                                            :
                                                                            item.point.status === 'Rejected' ?
                                                                                <Button type='ghost' style={{ fontSize: 12, color: "red" }}>Verifikasi Ditolak</Button>
                                                                                :
                                                                                null
                                                                    :
                                                                    <Button type='dashed' style={{ marginRight: 5 }} onClick={() => {
                                                                        setTransactionId(item.transaction_id);
                                                                        setModalUploadReceipt(true)
                                                                    }}>
                                                                        <div style={{ fontSize: 12 }}>Upload</div>
                                                                    </Button>
                                                            }
                                                        </>
                                                    } */}
                                                </Col>
                                            </Row>
                                        </List.Item>
                                    )}
                                </VirtualList>
                            </List>
                        </InfiniteScroll>
                        :
                        <div style={{ height: 500 }}>
                            <div style={{
                                textAlign: "center",
                                justifyContent: "center",
                                alignItems: "center",
                                position: 'absolute', left: '50%', top: '50%',
                                transform: 'translate(-50%, -50%)'
                            }}>
                                <ShoppingCartOutlined />
                                <b style={{ textAlign: "center" }}> Transaksi hari ini kosong</b>
                                <div>Belum ada transaksi hari ini. Silahkan melakukan transaksi terlebih dahulu</div>
                            </div>
                        </div>
                }
            </Modal>
            <Modal
                width={valueCustomer !== null && valueCustomer !== undefined ? 600 : 400}
                open={modalDone}
                footer={null}
                onCancel={() => removeState()}
            >
                <div style={{ padding: 20 }}>
                    <div style={{ textAlign: "center", marginBottom: 20 }}>
                        <b style={{ fontSize: "18px", color: "#4caf50" }}>Pembayaran Berhasil</b>
                    </div>
                    <Row gutter={[16, 16]} align="middle">
                        {/* Kolom Kiri */}
                        <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                            <Image
                                src="/assets/done.gif"
                                width={200}
                                height={150}
                                preview={false}
                                style={{ marginBottom: 20 }}
                            />
                        </Col>

                        {/* Kolom Kanan */}
                        <Col xs={24} sm={12}>
                            {pay !== null && pay !== undefined && valueMethod === "tunai" ? (
                                <h3>
                                    Kembalian : {currencyFormat(Number(pay) - grandTotal)}
                                </h3>
                            ) :
                                <h3>Berhasil Transaksi</h3>
                            }
                            {usePoint === false && cashbackPoint > 0 && (
                                <p>
                                    Cashback Point : <b>{currencyFormat(cashbackPoint)}</b>
                                </p>
                            )}
                        </Col>
                    </Row>
                    <Divider />
                    <Row gutter={[16, 16]}>
                        {/* Tombol Cetak Ulang */}
                        <Col xs={24} sm={12}>
                            <Button
                                disabled={loading}
                                type="primary"
                                block
                                icon={<PrinterOutlined />}
                                onClick={async () => {
                                    setLoading(true);
                                    if (dataPrint !== null && serialPort !== null) {
                                        await writePrintTry(serialPort, dataPrint);
                                        setLoading(false);
                                    }
                                }}
                            >
                                {loading === true ? "Loading..." : "Cetak Ulang"}
                            </Button>
                        </Col>

                        {/* <Col xs={24} sm={12}>
                            <Button
                                disabled={loading}
                                type="primary"
                                block
                                icon={<PrinterOutlined />}
                                onClick={async () => {
                                    setLoading(true);
                                    if (dataPrint !== null && serialPort !== null) {
                                        await writePrintTry(serialPort, dataPrint);
                                        setLoading(false);
                                    }
                                }}
                            >
                                {loading === true ? "Loading..." : "Cetak Ulang Html"}
                            </Button>
                        </Col> */}

                        {/* Tombol Download Invoice */}
                        <Col xs={24} sm={12}>
                            <Button
                                disabled={loading}
                                type="default"
                                block
                                icon={<FilePdfOutlined />}
                                onClick={async () => downloadInvoicePDF(dataPrint.transaction_code)}
                            >
                                {loading === true ? "Loading..." : "Download PDF"}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            {/* {
                valueCustomer !== null && valueCustomer !== undefined &&
                <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Upload Struk disini</p>
                    <p className="ant-upload-hint">
                        Upload Struk untuk verifikasi transaksi dan star
                    </p>
                </Dragger>
            } */}

            <Modal open={modalUploadReceipt} footer={null} onCancel={() => {
                setModalUploadReceipt(false)
                setImageReceiptUrl(null)
            }} >
                <div style={{ textAlign: "center" }}>
                    <h4>Upload Struk</h4>
                    {
                        imageReceiptUrl !== null && imageReceiptUrl !== undefined ?
                            <Image src={imageReceiptUrl} />
                            :
                            <Dragger onChange={(ev) => onUploadReceipt(ev)}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Upload Struk disini</p>
                                <p className="ant-upload-hint">
                                    Upload Struk untuk verifikasi transaksi dan star
                                </p>
                            </Dragger>
                    }
                    {
                        imageReceiptUrl !== null && imageReceiptUrl !== undefined &&
                        <div style={{ marginTop: 10, textAlign: "right" }}>
                            <Button type='default' danger style={{ marginRight: 5 }} onClick={() => setImageReceiptUrl(null)}>
                                <div style={{ fontSize: 12 }}>Hapus Gambar</div>
                            </Button>
                            <Button type='primary' style={{ marginRight: 5 }} onClick={() => SendUploadReceipt()}>
                                <div style={{ fontSize: 12 }}>Kirim</div>
                            </Button>
                        </div>
                    }
                </div>
            </Modal>

            <Modal
                title={
                    selectedMinPromo ? (
                        <div>
                            <b>{selectedMinPromo.title}</b>
                            <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                                Produk tebus murah tersedia
                            </div>
                        </div>
                    ) : (
                        <div>
                            <b>Pilih Promo Tebus Murah</b>
                            <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                                Klik promo untuk melihat produknya
                            </div>
                        </div>
                    )
                }
                open={modalMinPurchase}
                onCancel={() => {
                    setModalMinPurchase(false);
                    setSearchMinPurchase('');
                    setSelectedMinPromo(null);
                }}
                footer={null}
                width={760}
            >
                {selectedMinPromo && (
                    <Button
                        type="link"
                        onClick={() => {
                            setSelectedMinPromo(null);
                            setSearchMinPurchase('');
                        }}
                        style={{ paddingLeft: 0, marginBottom: 8 }}
                    >
                        ← Kembali ke daftar promo
                    </Button>
                )}

                <Search
                    placeholder={
                        selectedMinPromo
                            ? 'Cari produk / varian / SKU'
                            : 'Cari promo tebus murah'
                    }
                    allowClear
                    value={searchMinPurchase}
                    onChange={(e) => setSearchMinPurchase(e.target.value)}
                    style={{ marginBottom: 12 }}
                />

                {minPurchaseCart.length > 0 && (
                    <Alert
                        message={`${minPurchaseCart.length} produk tebus murah dipilih`}
                        type="success"
                        showIcon
                        style={{ marginBottom: 12 }}
                    />
                )}

                {!selectedMinPromo ? (
                    filteredShopMinPromo.length === 0 ? (
                        <Alert
                            message="Promo tebus murah tidak ditemukan"
                            type="info"
                            showIcon
                        />
                    ) : (
                        <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
                            {filteredShopMinPromo.map((promo) => (
                                <Card
                                    key={promo.min_purchase_product_id}
                                    hoverable
                                    size="small"
                                    onClick={() => {
                                        setSelectedMinPromo(promo);
                                        setSearchMinPurchase('');
                                    }}
                                    style={{
                                        marginBottom: 12,
                                        borderRadius: 12,
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Row align="middle">
                                        <Col span={17}>
                                            <b>{promo.title}</b>

                                            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                                                Minimal belanja {currencyFormat(promo.min_purchase)}
                                            </div>
                                        </Col>

                                        <Col span={7} style={{ textAlign: 'right' }}>
                                            <Tag color="green">
                                                {promo.min_purchase_items?.length || 0} Produk
                                            </Tag>

                                            <div style={{ fontSize: 11, color: '#999', marginTop: 6 }}>
                                                Klik lihat produk
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            ))}
                        </div>
                    )
                ) : (
                    <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
                        {(selectedMinPromo.min_purchase_items || [])
                            .filter((item) => {
                                const keyword = searchMinPurchase.toLowerCase();

                                const productName = item.product?.product_name || '';
                                const variantName = item.variant_product?.variant_name || '';
                                const sku = item.variant_product?.SKU || '';

                                return (
                                    productName.toLowerCase().includes(keyword) ||
                                    variantName.toLowerCase().includes(keyword) ||
                                    sku.toLowerCase().includes(keyword)
                                );
                            })
                            .map((item) => {
                                const isAdded = minPurchaseCart.some(
                                    (cart) =>
                                        Number(cart.variant_product_id) ===
                                        Number(item.variant_product_id)
                                );

                                const productName = item.product?.product_name || '-';
                                const variantName =
                                    item.variant_product?.variant_name ||
                                    item.variant_product?.SKU ||
                                    '-';

                                return (
                                    <Card
                                        key={item.variant_product_id}
                                        size="small"
                                        onClick={() => {
                                            if (isAdded) {
                                                deleteMinPurchaseItem(item);
                                            } else {
                                                addMinPurchaseItem(item);
                                            }
                                        }}
                                        style={{
                                            marginBottom: 10,
                                            borderRadius: 12,
                                            cursor: 'pointer',
                                            border: isAdded
                                                ? '1px solid #52c41a'
                                                : '1px solid #f0f0f0',
                                            background: isAdded ? '#f6ffed' : '#fff',
                                        }}
                                    >
                                        <Row align="middle">
                                            <Col span={16}>
                                                <div style={{ fontSize: 13, fontWeight: 600 }}>
                                                    {productName}
                                                </div>

                                                <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                                                    {variantName}
                                                </div>

                                                <Space style={{ marginTop: 6 }}>
                                                    <Tag color="green" style={{ margin: 0 }}>
                                                        {currencyFormat(item.price)}
                                                    </Tag>

                                                    {isAdded && (
                                                        <Tag color="blue" style={{ margin: 0 }}>
                                                            Sudah ditebus
                                                        </Tag>
                                                    )}
                                                </Space>
                                            </Col>

                                            <Col span={8} style={{ textAlign: 'right' }}>
                                                <Button
                                                    type={isAdded ? 'primary' : 'default'}
                                                    danger={isAdded}
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        if (isAdded) {
                                                            deleteMinPurchaseItem(item);
                                                        } else {
                                                            addMinPurchaseItem(item);
                                                        }
                                                    }}
                                                >
                                                    {isAdded ? 'Batal' : 'Tebus'}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                );
                            })}
                    </div>
                )}
            </Modal>
        </div >
    );
}

export default POS;